<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="grey lighten-3" elevation="1">
							<bc-btn-back></bc-btn-back>
							<v-toolbar-title class="ml-0">{{ `Device - ${device.public_id}` }}</v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-btn-add v-if="hasPerm('devices.update') && device.company_id != null"
								@invoke-method="invokeMethod($event)" action="openPortDialog"
								:tooltip="$t('lang.add_port')"></bc-btn-add>
							<bc-tooltip
								v-if="hasPerm('transaction_documents.create') && device.ports != null && device.ports.length > 0"
								class="hidden-sm-and-down">
								<template slot="activator">
									<v-btn icon @mouseup.left="openOrderDialog()">
										<v-icon>water_drop</v-icon>
									</v-btn>
								</template>
								Add Order
							</bc-tooltip>
							<bc-tooltip v-if="hasPerm('devices.update')" class="hidden-sm-and-down">
								<template slot="activator">
									<v-btn icon @mouseup.left="openDeviceDialog()">
										<v-icon>edit</v-icon>
									</v-btn>
								</template>
								{{ $t("lang.modify_device") }}
							</bc-tooltip>
							<bc-btn-refresh @invoke-method="dbGetDevice(true)"></bc-btn-refresh>
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="fullMobileList"
								persistent></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>

				<v-container grid-list-xl v-if="device != null">
					<v-layout row :wrap="$bp.smallScreen">
						<v-flex xl2 xs12 md4 lg2 align-self-start pb-0 :pl-0="!$bp.smallScreen">
							<!-- START STATUS -->
							<v-layout row wrap>
								<v-flex py-1 d-flex>
									<v-flex xs6 class="text-center"
										style="background-color: #eeeeee; margin-right: 5px">
										<div @mouseup.left="openSignalGraph()" class="clickable"
											style="text-transform: uppercase">
											<v-icon
												:color="device.connectivity == 'offline' ? 'red' : device.signal_quality_class">{{
													device.connectivity == "online" ? device.signal_quality_icon :
														"warning_amber"
												}}</v-icon>
											<span v-if="!$bp.mediumScreen">{{ device.connectivity | capitalize }}</span>
										</div>
									</v-flex>
									<v-flex xs6 class="text-center" style="background-color: #eeeeee">
										<div @mouseup.left="openTemperatureGraph()" class="clickable"
											v-if="device.temperature_imperial != null && device.temperature_metric != null">
											<v-icon :color="device.temperature_class">thermostat</v-icon>
											{{
												this.current_user.unit_of_measure == "0" && device.temperature_imperial
													? device.temperature_imperial + "&deg;F"
													: device.temperature_metric + "&deg;C"
											}}
										</div>
									</v-flex>
								</v-flex>

								<!-- <v-flex py-1>
									
                                    <ul class="deviceInfo">
                                        <li style="float: left !important; display: inline-block; width: 49%; margin-right: 5px !important">
                                            
                                        </li>
                                        <li style="float: left !important; display: inline-block; width: 49%">
                                            
                                            <div v-else>
                                                <v-icon color="error">thermostat</v-icon>
                                                No Temp
                                            </div>
                                        </li>
                                    </ul>
                                </v-flex> -->
							</v-layout>
							<!-- END STATUS -->

							<v-layout row wrap>
								<v-flex py-1>
									<p class="display-1 mb-0 text-xs-center">{{ device.label }}</p>
									<p class="display-0 mb-0 text-xs-center">{{ device.company }}</p>
								</v-flex>
							</v-layout>
							<v-divider class="my-0"></v-divider>

							<!-- START TEMP & SURGE -->
							<v-layout row wrap>
								<v-flex py-1>
									<v-flex xs12 class="text-center" style="background-color: #eeeeee">
										<div :class="{ 'surge-error': device.surge_protection == '0' }">
											<v-icon :color="device.surge_protection == '0' ? 'red' : 'green'">{{
												device.surge_protection == "0" ? "power_off" : "power"
											}}</v-icon>
											{{ device.surge_protection == "0" ?
												"No Surge Protection"
												:
												"Surge Protection Installed" }}
										</div>
									</v-flex>
								</v-flex>
							</v-layout>
							<!-- END TEMP & SURGE -->

							<v-divider class="my-0"></v-divider>

							<!-- START ADDRESS -->
							<v-flex shrink pa-0 :mr-3="(device.entity_addresses || []).length > 0"
								v-readonly-click="hasPerm('devices.update') ? false : true">
								<div v-if="(device.entity_addresses || []).length > 0" class="clickable ml-auto">
									<v-container grid-list-form
										@mouseup.left="hasPerm('devices.update') ? $refs.addressDialog.showAddress(device.entity_addresses[0]) : null">
										<!-- v-for="(address, k) in entity_addresses" :key="k" -->
										<v-layout row class="my-0 pt-1 pb-0 list-item"
											:class="{ 'list-hover': !$bp.smallScreen }">
											<v-flex xs2 class="my-auto list-icon">
												<v-icon color="primary">location_on</v-icon>
											</v-flex>
											<v-flex class="xs10 list-slot">
												<v-flex v-if="device.entity_addresses[0].location_label">{{
													device.entity_addresses[0].location_label
												}}</v-flex>
												<v-flex list-sub>{{ device.entity_addresses[0].address1 }}</v-flex>
												<v-flex list-sub>{{
													`${device.entity_addresses[0].city ? device.entity_addresses[0].city
														+ "," : ""} ${device.entity_addresses[0].state || ""
													} ${device.entity_addresses[0].zip_code || ""}`
												}}</v-flex>
											</v-flex>
										</v-layout>
									</v-container>
								</div>
								<v-btn v-else flat right class="px-2 py-1 mt-0 mr-0 h-100 ml-auto" color="primary"
									style="width: 150px" @mouseup.left="$refs.addressDialog.showAddress()">
									<v-icon left dark>location_on</v-icon>
									Add Address
								</v-btn>
							</v-flex>
							<!-- END ADDRESS -->

							<v-divider class="my-0"></v-divider>

							<!-- START TAGS -->
							<v-layout row wrap>
								<v-flex xs12 py-0>
									<v-item-group class="light-gray-bg border-rad-md"
										:class="$bp.xsOnly ? 'pa-1' : 'pa-2'">
										<v-item v-if="currentTags.length > 0" v-for="tag in currentTags"
											:key="tag.tag_id">
											<v-chip slot-scope="{}" class="device-tag" outline small
												@click="hasPerm('devices.update') ? showTag(true) : null"
												@input="openRemoveTagFromDeviceDialog(tag.tag_id)">
												<v-list-tile-content class="black--text">
													<v-list-tile-title>{{ tag.tag }}</v-list-tile-title>
												</v-list-tile-content>
											</v-chip>
										</v-item>
										<v-item>
											<v-chip v-if="hasPerm('devices.update')" slot-scope="{}"
												class="clickable device-tag add-tag" small disabled
												@mouseup.left.stop.prevent="showTag(), (device_tag_mode = 'add')"
												color="primary" text-color="white">
												<v-list-tile-content>
													<v-list-tile-title>Attach Tag</v-list-tile-title>
												</v-list-tile-content>
											</v-chip>
										</v-item>
									</v-item-group>
									<v-spacer></v-spacer>
								</v-flex>
							</v-layout>
							<!-- END TAGS -->

							<v-divider class="my-0"></v-divider>

							<!-- START INFO -->
							<bc-list prepend-icon="info" prepend-position="top" perm="parts.update" icon-color="primary"
								font-size="12">
								<template>
									<v-container pa-2>
										<v-layout row wrap>
											<v-flex xs6 mt-1>{{ `${$t("lang.device_type")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.device_type ? device.device_type : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.formatted_version")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.formatted_version ?
												device.formatted_version : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.record_interval")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.record_interval ?
												device.record_interval_display : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.queued_records")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.queued_records ? device.queued_records :
												"---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.users_last_record_date")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.users_last_record_date ?
												device.users_last_record_date : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.voltage")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.battery ? device.battery + "v" : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.purchase_date")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.purchase_date ? device.purchase_date :
												"---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.device_status")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1 class="text-capitalize">{{ device.status ?
												device.status : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.total_products")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.total_products ? device.total_products :
												"---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.last_edit")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.last_updated_by ? device.last_updated_by
												: device.created_by }}</v-flex>
										</v-layout>
									</v-container>
								</template>
							</bc-list>
							<!-- END INFO -->

							<v-divider class="my-0"></v-divider>

							<!-- START CELL INFO -->
							<bc-list prepend-icon="cell_tower" prepend-position="top" perm="parts.update"
								icon-color="primary" font-size="12">
								<template>
									<v-container pa-2>
										<v-layout row wrap>
											<v-flex xs6 mt-1>{{ `${$t("lang.imei")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.mobile && device.mobile.imei ?
												device.mobile.imei : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.sim")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>
												<span v-if="device && device.mobile && device.mobile.sim"
													style="cursor: pointer"
													@click.stop="$copyToClipboard(device.mobile.sim)">
													<bc-tooltip>
														<template slot="activator">
															<span>{{ $textTruncate(device.mobile.sim, 15) }}</span>
															<v-icon class="fw-light ml-1" small>content_copy</v-icon>
														</template>
														Copy Sim #
													</bc-tooltip></span>
												<span v-else>---</span></v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.sim_provider")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device && device.mobile_provider ?
												device.mobile_provider : "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.sim_state")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device && device.mobile && device.mobile.sim_state ?
													device.mobile.sim_state : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.ip_address")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device && device.ip_address ? device.ip_address
												: "---" }}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.last_network_used")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device.mobile && device.mobile.last_network_used ?
													device.mobile.last_network_used : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.last_connected")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device && device.mobile && device.mobile.last_connected ?
													device.mobile.last_connected : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.radio_tech")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device && device.mobile && device.mobile.radio_tech ?
													device.mobile.radio_tech : "---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.billing_data_usage")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device && device.mobile && device.mobile.current_billing_data
													? (Math.ceil(device.mobile.current_billing_data / 10000) * 1.0) / 100 +
													" MB"
													: "---"
											}}
												//
												{{
													device && device.mobile && device.mobile.overage_limit
														? (Math.ceil(device.mobile.overage_limit / 10000) * 1.0) / 100 + " MB"
														: "---"
												}}</v-flex>
										</v-layout>
									</v-container>
								</template>
							</bc-list>
							<!-- END CELL INFO -->
							<v-divider class="my-0"></v-divider>
							<bc-list v-if="device.subscriptions != null" prepend-icon="autorenew" prepend-position="top"
								perm="parts.update" icon-color="primary" font-size="12">
								<template>
									<v-container pa-2>
										<v-layout row wrap>
											<v-flex xs6 mt-1>{{ `${$t("lang.term_length")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device.subscriptions.term_length ? device.subscriptions.term_length +
													"Months"
													:
													"-- - "
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.period_start")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{
												device.subscriptions.period_start ? device.subscriptions.period_start :
													"---"
											}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.period_end")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1>{{ device.subscriptions.period_end ?
												device.subscriptions.period_end : "---" }}</v-flex>

											<v-flex xs6 mt-1
												v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">{{
													`${$t("lang.amount")}:`
												}}</v-flex>
											<v-flex xs6 fw-bold mt-1
												v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">{{
													device.subscriptions.amount ? device.subscriptions.amount : "---"
												}}</v-flex>

											<v-flex xs6 mt-1
												v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">{{
													`${$t("lang.paid")}:`
												}}</v-flex>
											<v-flex xs6 fw-bold mt-1
												v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">{{
													device.subscriptions.paid ? (device.subscriptions.paid == "1" ? "Yes" :
														"No") : "---"
												}}</v-flex>

											<v-flex xs6 mt-1>{{ `${$t("lang.status")}:` }}</v-flex>
											<v-flex xs6 fw-bold mt-1 class="text-capitalize">{{
												device.subscriptions.status ? device.subscriptions.status : "---"
											}}</v-flex>
										</v-layout>
									</v-container>
								</template>
							</bc-list>

							<!-- START NOTES -->
							<!--<v-layout row wrap>
                                <v-flex xs12 py-2>
                                    <bc-notes-list
                                        :items="device.notes"
                                        perm="device.update"
                                        entity-object="Devices"
                                        :api-url="`devices/${this.$route.params.id}`"
                                        :scope="device.scope"
                                        state-property="device.notes"
                                    ></bc-notes-list>
                                </v-flex>
                            </v-layout>-->
							<!-- END NOTES -->
						</v-flex>
						<v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
						<!-- <v-flex v-if="!$bp.mdAndDown" xs12 md8 lg10 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-data-table :headers="port_headers" :items="device.ports || []" :no-data-text="$t('lang.no_data_available')" hide-actions>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>
                                            <h3 class="ma-0">{{ props.item.product_name }}</h3>
                                            <small>{{ props.item.sensor_type }}</small>
                                        </td>
                                        <td class="text-center">
                                            {{ ($bp.xsOnly ? `V` : "") + props.item.port_number }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                props.item.user_available_capacity
                                                    ? props.item.user_available_capacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                    : 0
                                            }}
                                        </td>
                                        <td>
                                            <bc-charts chart-type="bullet" :chart-data="props.item"></bc-charts>
                                        </td>
                                        <td>
                                            <v-layout row>
                                                <v-btn
                                                    v-if="hasPerm('devices.update')"
                                                    class="ml-auto mr-1 my-auto"
                                                    icon
                                                    @mouseup.left="openPortDialog(props.item)"
                                                >
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn
                                                    v-if="props.item.percent_full != null"
                                                    class="mx-0 my-auto"
                                                    icon
                                                    @mouseup.left="openPortHistoryDialog(props.item)"
                                                >
                                                    <v-icon>history</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex> -->
						<v-flex xl10 lg10 md8 xs12 style="height: 512px">
							<v-layout row wrap>
								<v-flex xl4 lg4 md6 xs12 v-if="$isArraySet(device.ports)" v-for="port in device.ports"
									:key="port.device_ports_id">
									<v-card height="100%">
										<v-card-title class="text-center justify-center">
											<div>
												<h2 class="ma-0">
													<strong>{{ port.product_name.toUpperCase() }}</strong>
												</h2>
												<small style="font-size: 16px">{{ port.sensor_type }}</small>
												&#124;
												<small style="font-size: 16px">Port {{ port.port_number }}</small>
												<br />
												<small>Last Edit:
													{{ port.last_updated_by ? port.last_updated_by : port.created_by ?
														port.created_by :
														"Imported" }}</small>
											</div>
											<!-- <v-spacer></v-spacer>
                                            <v-card-actions>
                                                <v-btn v-if="hasPerm('devices.update')" class="ml-auto mr-1 my-auto" icon @mouseup.left="openPortDialog(port)">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn v-if="port.percent_full != null" class="mx-0 my-auto" icon @mouseup.left="openPortHistoryDialog(port)">
                                                    <v-icon>history</v-icon>
                                                </v-btn>
                                            </v-card-actions> -->
										</v-card-title>
										<v-card-text style="height: 384px">
											<div v-if="port.sensor_type_id != 4">
												<div v-if="port.percent_full > 100" class="text-center mb-auto">
													<v-icon color="error" class="mr-1">error</v-icon>
													<span class="font-weight-bold" style="color: #ff3139">Over Capacity
														- {{ port.percent_full
														}}%</span>
													<br />
													<small
														style="position: relative; bottom: 6px; color: #ff3139">Possible
														sensor
														malfunction</small>
												</div>
												<div v-else class="text-center">
													<span class="mb-0">{{ port.percent_full }}% Full</span>
												</div>
												<fusioncharts type="cylinder" width="100%" height="256"
													data-format="json" :dataSource="{
														chart: {
															autoScale: '1',
															cylRadius: '100',
															lowerLimit: '0',
															upperLimit:
																current_user.unit_of_measure_display == 'metric'
																	? port.total_liters_capacity
																	: port.total_gallons_capacity,
															numberSuffix: current_user.unit_of_measure_display == 'metric' ? 'L' : 'G',
															lowerLimitDisplay: 'Empty',
															showValue: '0',
															theme: 'fusion',
															cylFillColor: port.tank_color_class,
															chartBottomMargin: '0',
															chartLeftMargin: '40',
															chartRightMargin: '0',
															captionFont: 'Heebo, sans-serif',
														},
														value: port.user_fill_volume,
													}">
												</fusioncharts>
												<v-layout row wrap mb-auto>
													<v-flex xs6 pa-0>
														<div class="text-center">
															<h4 class="mb-0">{{ port.user_fill_volume }}{{
																port.user_symbol }}</h4>
															<small>On Hand</small>
														</div>
													</v-flex>
													<v-flex xs6 pa-0>
														<div class="text-center">
															<h4 class="mb-0">{{ port.user_available_capacity }}{{
																port.user_symbol }}</h4>
															<small>Available Capacity</small>
														</div>
													</v-flex>
												</v-layout>
											</div>

											<div v-else>
												<fusioncharts type="thermometer" width="100%" height="256"
													data-format="json" :dataSource="{
														chart: {
															autoScale: '1',
															thmBulbRadius: '25',
															lowerLimit: '-10',
															upperLimit: '140',
															numberSuffix: current_user.unit_of_measure_display == 'metric' ? '°C' : '°F',
															theme: 'fusion',
															chartBottomMargin: '0',
															chartRightMargin: '0',
															thmFillColor: '#00D031',
														},
														value: port.user_temperature,
													}"></fusioncharts>
												<div class="text-center">
													<h4 class="mb-0">
														{{ port.user_temperature }} {{
															current_user.unit_of_measure_display == "metric" ? "°C" :
																"°F" }}
													</h4>
													<small>Latest Temperature</small>
												</div>
											</div>

											<!-- <v-layout row wrap>
                                                <v-flex xs6>
                                                    <div class="text-center">
                                                        <h3 class="ma-0">
                                                            {{
                                                                port.user_fill_volume
                                                                    ? port.user_fill_volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                                    : 0
                                                            }}
                                                            ({{ port.user_symbol }})
                                                        </h3>
                                                        <small>{{ $t("lang.on_hand") }}</small>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <div class="text-center">
                                                        <h3 class="ma-0">
                                                            {{
                                                                port.user_available_capacity
                                                                    ? port.user_available_capacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                                    : 0
                                                            }}
                                                            ({{ port.user_symbol }})
                                                        </h3>
                                                        <small>{{ $t("lang.available") }}</small>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <bc-charts chart-type="bullet" :chart-data="port"></bc-charts> -->
										</v-card-text>
										<v-card-actions class="mt-auto">
											<v-flex xs6 class="pa-0 mr-2">
												<v-btn v-if="hasPerm('devices.update')" class="my-auto w-100"
													color="primary" @mouseup.left="openPortDialog(port)">
													<v-spacer></v-spacer>
													<v-icon small class="mr-2">edit</v-icon>
													Edit
													<v-spacer></v-spacer>
													<v-chip
														v-if="port.tank_specs && port.tank_specs.filter((x) => x.tank_size_difference_display).length > 0"
														small disabled color="warning"
														style="height: 16px !important">{{
															port.tank_specs.filter((x) =>
																x.tank_size_difference_display).length}}</v-chip>
												</v-btn>
											</v-flex>
											<v-flex xs6 class="pa-0">
												<v-btn v-if="port.percent_full != null" class="mx-0 my-auto w-100"
													color="primary" @mouseup.left="openPortHistoryDialog(port)">
													<v-icon small class="mr-2">history</v-icon>
													History
												</v-btn>
											</v-flex>
										</v-card-actions>
									</v-card>
								</v-flex>
							</v-layout>
						</v-flex>

						<!-- <v-flex v-else xs12 md8 lg10 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-card v-for="port in device.ports" :key="port.device_ports_id">
                                <v-card-title>
                                    <div>
                                        <h3 class="ma-0">{{ port.product_name }}</h3>
                                        <small>{{ port.sensor_type }} </small>&#124;
                                        <small>Port {{ port.port_number }}</small>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-card-actions>
                                        <v-btn v-if="hasPerm('devices.update')" class="ml-auto mr-1 my-auto" icon @mouseup.left="openPortDialog(port)">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="port.percent_full != null" class="mx-0 my-auto" icon @mouseup.left="openPortHistoryDialog(port)">
                                            <v-icon>history</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <div class="text-center">
                                                <h3 class="ma-0">
                                                    {{ port.user_fill_volume ? port.user_fill_volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }} ({{
                                                        port.user_symbol
                                                    }})
                                                </h3>
                                                <small>{{ $t("lang.on_hand") }}</small>
                                            </div>
                                        </v-flex>
                                        <v-flex xs6>
                                            <div class="text-center">
                                                <h3 class="ma-0">
                                                    {{
                                                        port.user_available_capacity
                                                            ? port.user_available_capacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                            : 0
                                                    }}
                                                    ({{ port.user_symbol }})
                                                </h3>
                                                <small>{{ $t("lang.available") }}</small>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                    <bc-charts chart-type="bullet" :chart-data="port"></bc-charts>
                                </v-card-text>
                            </v-card>
                        </v-flex> -->
					</v-layout>
				</v-container>
			</v-card>
		</v-container>
		<bc-address-dialog ref="addressDialog" object_ref="devices" :object_id="$route.params.id"
			:total_items="device.entity_addresses || []" :scope="device.scope" @eventname="changeAddress" :prime="true"
			:is_prime="true" :display_address_type="false"></bc-address-dialog>

		<bc-dialog :value="iot_device_dialog" max-width="700">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.edit_device") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="iot_device_dialog"
						:dialog-status="iot_device_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-form ref="iot_device">
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12 sm6>
									<bc-autocomplete v-model="device_company_id" :label="`${$t('lang.company')} *`"
										:initial="device.company" :items="customer_options" item-value="company_id"
										item-text="company" :rules="ifValid('devices.company_id')"
										:append-icon="device.total_products > 0 ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="device.total_products > 0 ? true : false"></bc-autocomplete>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field v-if="device" v-model="device.public_id" :label="$t('lang.public_id')"
										readonly append-icon="lock" v-readonly-click></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field v-model="device.label" :label="`${$t('lang.label')} *`"
										:counter="showCounter(device.label, 'device.label')"
										:rules="ifValid('devices.label')"></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-date-picker v-model="device.purchase_date"
										:label="`${$t('lang.purchase_date')} *`"
										:rules="ifValid('devices.purchase_date')"
										@update="device.purchase_date = $event"
										:icon="isNotInternalUser() ? 'lock' : ''"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-date-picker>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-select v-model="device.surge_protection"
										:label="`${$t('lang.surge_protection')} *`" :items="surge_protection"
										item-value="value" item-text="text"
										:rules="ifValid('devices.surge_protection')"></bc-select>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-select v-model="device.warranty_period"
										:label="`${$t('lang.warranty_period')} *`" :items="warranty_period"
										item-value="value" item-text="text" :rules="ifValid('devices.warranty_period')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-select>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-select v-model="device.device_type_id" :label="`${$t('lang.device_type')} *`"
										:items="device_types" item-value="device_type_id" item-text="device_type"
										:rules="ifValid('devices.device_type_id')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-select>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-autocomplete v-model="device.firmware_version_id"
										:label="`${$t('lang.version')} *`" :initial="device.formatted_version"
										:items="firmware" item-value="firmware_version_id" item-text="formatted_version"
										:rules="ifValid('devices.firmware_version_id')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-autocomplete>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-autocomplete v-model="device.record_interval"
										:label="`${$t('lang.record_interval')} *`" :items="record_intervals"
										item-value="value" item-text="text" :rules="ifValid('devices.record_interval')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-autocomplete>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-select v-model="device.mobile_provider_id"
										:label="`${$t('lang.mobile_provider')} *`" :items="mobile_providers"
										item-value="mobile_provider_id" item-text="mobile_provider"
										:rules="ifValid('devices.mobile_provider_id')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-select>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field v-model="device.temperature_low_threshold"
										:label="`${$t('lang.temperature_low_threshold')}`"
										:counter="showCounter(device.temperature_low_threshold, 'device.temperature_low_threshold')"
										:rules="ifValid('devices.temperature_low_threshold')"></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field v-model="device.temperature_high_threshold"
										:label="`${$t('lang.temperature_high_threshold')}`"
										:counter="showCounter(device.temperature_high_threshold, 'device.temperature_high_threshold')"
										:rules="ifValid('devices.temperature_high_threshold')"></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<bc-select v-model="device.status" :label="`${$t('lang.status')} *`" :items="status"
										item-value="value" item-text="text" :rules="ifValid('devices.status')"
										:append-icon="isNotInternalUser() ? 'lock' : 'arrow_drop_down'"
										v-readonly-click="isNotInternalUser() ? true : false"></bc-select>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="iot_device_dialog = false">{{ $t("lang.cancel") }}</v-btn>
					<v-btn color="success" @mouseup.left="modifyDevice()">{{ $t("lang.save") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>

		<bc-dialog :value="port_dialog" max-width="1200">
			<v-card>
				<v-card-title>
					<span class="headline">{{ currPortField("device_ports_id") ? $t("lang.edit_device_port") :
						$t("lang.add_device_port") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closePortDialog"
						dialog-model="port_dialog" :dialog-status="port_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text :class="{ 'px-0': $bp.smallScreen }">
					<v-form ref="iot_device_port" :class="{ 'px-3': $bp.smallScreen }">
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12 sm6 align-self-start>
									<v-layout row wrap inner-layout>
										<v-flex xs12>
											<bc-autocomplete v-model="iot_device_port.product_id"
												:label="`${$t('lang.product_id')} *`"
												:initial="currPortField('product_name')" :items="tank_products"
												item-value="product_id" item-text="product_name"
												:rules="ifValid('iot_device_port.product_id')"></bc-autocomplete>
										</v-flex>
										<v-flex xs12>
											<bc-select v-model="iot_device_port.port_number"
												:label="`${$t('lang.port_number')} *`" :items="portNumberOptions || []"
												:rules="ifValid('iot_device_port.port_number')"></bc-select>
										</v-flex>
										<v-flex xs12>
											<bc-autocomplete
												v-if="current_port && current_port.tank_specs && current_port.tank_specs.length > 0"
												v-model="iot_device_port.sensor_type_id"
												:label="`${$t('lang.sensor_type_id')} *`"
												:initial="currPortField('sensor_type')" :items="sensor_types"
												item-value="sensor_type_id" item-text="sensor_type"
												:rules="ifValid('iot_device_port.sensor_type_id')" append-icon="lock"
												:disabled="true"></bc-autocomplete>
											<bc-autocomplete v-else v-model="iot_device_port.sensor_type_id"
												:label="`${$t('lang.sensor_type_id')} *`"
												:initial="currPortField('sensor_type')" :items="sensor_types"
												item-value="sensor_type_id" item-text="sensor_type"
												:rules="ifValid('iot_device_port.sensor_type_id')"></bc-autocomplete>
										</v-flex>
										<v-flex xs12 v-if="iot_device_port && iot_device_port.sensor_type_id != '4'">
											<bc-select v-if="current_port && current_port.tank_specs.length > 0"
												v-model="iot_device_port.tank_type_id"
												:label="`${$t('lang.tank_type_id')} *`"
												:initial="currPortField('tank_type')" :items="tank_types"
												item-value="tank_type_id" item-text="tank_type"
												:rules="ifValid('iot_device_port.tank_type_id')"
												@change="adjustHeaders(tank_types.find((obj) => obj.tank_type_id == iot_device_port.tank_type_id).formula)"
												append-icon="lock" :disabled="true">
											</bc-select>
											<bc-select v-else v-model="iot_device_port.tank_type_id"
												:label="`${$t('lang.tank_type_id')} *`"
												:initial="currPortField('tank_type')" :items="tank_types"
												item-value="tank_type_id" item-text="tank_type"
												:rules="ifValid('iot_device_port.tank_type_id')"
												@change="adjustHeaders(tank_types.find((obj) => obj.tank_type_id == iot_device_port.tank_type_id).formula)"></bc-select>
										</v-flex>

										<v-flex xs6 v-if="iot_device_port && iot_device_port.sensor_type_id != '4'">
											<v-text-field v-model="iot_device_port.reorder_yellow"
												:label="$t('lang.reorder_yellow')"
												:counter="showCounter(iot_device_port.reorder_yellow, 'iot_device_port.reorder_yellow')"
												:rules="ifValid('iot_device_port.reorder_yellow')"
												class="mr-1"></v-text-field>
										</v-flex>
										<v-flex xs6 v-if="iot_device_port && iot_device_port.sensor_type_id != '4'">
											<v-text-field v-model="iot_device_port.reorder_red"
												:label="$t('lang.reorder_red')"
												:counter="showCounter(iot_device_port.reorder_red, 'iot_device_port.reorder_red')"
												:rules="ifValid('iot_device_port.reorder_red')"
												class="ml-1"></v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 sm6 mb-2>
									<v-layout row wrap v-if="iot_device_port && iot_device_port.sensor_type_id != '4'">
										<v-flex xs12 v-if="!!iot_device_port.tank_type_id" pa-0 ma-auto>
											<v-card flat>
												<v-img max-height="300px" max-width="300px" class="mx-auto" :src="currPortField('tank_type_id') == iot_device_port.tank_type_id
													? currPortField('image_url')
													: currTankTypeField('image_url')
													"></v-img>
											</v-card>
										</v-flex>
										<v-flex xs12 v-else align-center text-center fs-32 grey--text>
											{{ $t("lang.select_tank_to_view") }}
										</v-flex>
										<v-flex xs12 :class="{ 'mt-auto': !!iot_device_port.tank_type_id }"
											v-if="currPortField('device_ports_id')">
											<v-btn class="ml-auto mt-auto"
												:class="$bp.smallScreen ? 'mb-3 mr-0' : 'mt-0'" color="primary"
												@mouseup.left="openPortTank()"
												:disabled="this.current_port.sensor_type_id == '4' ? true : false">
												{{ $t("lang.add_tank") }}
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
					<v-form v-if="current_port != null && iot_device_port && iot_device_port.sensor_type_id != '4'">
						<v-data-table v-if="adjusted_headers.length > 0" :headers="adjusted_headers"
							:items="current_port.tank_specs || []" :no-data-text="$t('lang.no_data_available')"
							hide-actions>
							<template slot="items" slot-scope="props">
								<tr v-if="current_user.unit_of_measure_display == 'metric'"
									@click="openPortTank(props.item)" class="clickable">
									<td class="px-2 prevent-click text-center">{{ "#" + (props.index + 1) }}</td>
									<td class="px-2 prevent-click">
										<bc-tooltip v-if="props.item.tank_size_difference_display != null">
											<template slot="activator">
												<v-icon color="warning">warning</v-icon>
											</template>
											{{ props.item.tank_size_difference_display }}
										</bc-tooltip>
										{{ props.item.def_liters }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('l')">
										{{ props.item.metric_length }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('w')">
										{{ props.item.metric_width }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('h')">
										{{ props.item.metric_height }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('d')">
										{{ props.item.metric_diameter }}
									</td>
									<td class="px-2 prevent-click">
										{{ props.item.sensor_offset }}
									</td>
									<td class="px-2 prevent-click">
										{{
											props.item.last_updated_by ? props.item.last_updated_by : props.item.created_by
												?
												props.item.created_by : "Imported"
										}}
									</td>
									<td class="px-2">
										<v-btn color="primary" @click.stop="duplicateTank(props.item)">Duplicate</v-btn>
									</td>
								</tr>
								<tr v-else @click="openPortTank(props.item)" class="clickable">
									<td class="px-2 prevent-click text-center">{{ "#" + (props.index + 1) }}</td>
									<td class="px-2">
										<bc-tooltip v-if="props.item.tank_size_difference_display != null">
											<template slot="activator">
												<v-icon color="warning">warning</v-icon>
											</template>
											{{ props.item.tank_size_difference_display }}
										</bc-tooltip>
										{{ props.item.def_us_gallons }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('l')">
										{{ props.item.imperial_length }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('w')">
										{{ props.item.imperial_width }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('h')">
										{{ props.item.imperial_height }}
									</td>
									<td class="px-2 prevent-click" v-if="currentFormula.includes('d')">
										{{ props.item.imperial_diameter }}
									</td>
									<td class="px-2 prevent-click">
										{{ props.item.imperial_sensor_offset }}
									</td>
									<td class="px-2 prevent-click">
										{{
											props.item.last_updated_by ? props.item.last_updated_by : props.item.created_by
												?
												props.item.created_by : "Imported"
										}}
									</td>
									<td class="px-2 text-right">
										<v-btn color="primary" @click.stop="duplicateTank(props.item)">Duplicate</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn v-if="currPortField('device_ports_id')" color="error"
						@mouseup.left="$refs.delete_port.openDialog()">{{ $t("lang.delete") }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="closePortDialog()">{{ $t("lang.cancel") }}</v-btn>
					<v-btn color="success" @mouseup.left="modifyPort()">{{ $t("lang.save") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>

		<bc-dialog :value="port_tank_dialog" v-if="current_port && current_port.sensor_type_id != '4'">
			<v-card>
				<v-card-title>
					<span class="headline">{{
						currTankField("id") && current_port && current_port.tank_specs
							? $t("lang.edit_tank") + " #" + (current_port.tank_specs.findIndex((tank) => tank.id ==
								currTankField("id")) + 1)
							: $t("lang.add_tank")
					}}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closePortTankDialog"
						:dialog-status="port_tank_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-form ref="iot_device_port_tank">
						<v-container grid-list-form>
							<v-layout row wrap v-if="current_user.unit_of_measure_display == 'imperial'">
								<v-flex xs12 v-if="isJason(current_user) && !$isSet(current_tank.id)">
									<bc-autocomplete v-model="selectedTankSpec" :items="manu_tank_specs || []"
										item-value="tank_spec_id" item-text="def_us_gallons" label="Tank Spec"
										@change="setTankSpec()">
										<template v-slot:selection="data">
											<div style="display: flex; flex-direction: column">
												<div>
													{{ data.item.tank_type }} - <strong>{{ data.item.def_us_gallons
													}}G</strong>
												</div>
												<div>
													<small v-if="$isSet(data.item.imperial_height)">Height: <strong>{{
														data.item.imperial_height }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_length)">Length: <strong>{{
														data.item.imperial_length }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_width)">Width: <strong>{{
														data.item.imperial_width }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_diameter)">Diameter:
														<strong>{{ data.item.imperial_diameter }}in </strong>
													</small>
												</div>
											</div>
										</template>
										<template v-slot:item="data">
											<div style="display: flex; flex-direction: column" class="pa-2">
												<div>
													{{ data.item.tank_type }} - <strong>{{ data.item.def_us_gallons
													}}G</strong>
												</div>
												<div>
													<small v-if="$isSet(data.item.imperial_height)">Height: <strong>{{
														data.item.imperial_height }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_length)">Length: <strong>{{
														data.item.imperial_length }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_width)">Width: <strong>{{
														data.item.imperial_width }}in </strong>
													</small>
													<small v-if="$isSet(data.item.imperial_diameter)">Diameter:
														<strong>{{ data.item.imperial_diameter }}in </strong>
													</small>
												</div>
											</div>
										</template></bc-autocomplete>
								</v-flex>
								<v-flex xs12>
									<v-text-field :focus="port_tank_dialog"
										v-model="iot_device_port_tank_imperial.def_us_gallons"
										:label="`${$t('lang.imperial_size')} *`"
										:counter="showCounter(iot_device_port_tank_imperial.def_us_gallons, 'iot_device_port_tank_imperial.def_us_gallons')"
										:rules="ifValid('iot_device_port_tank_imperial.def_us_gallons')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('l')">
									<v-text-field v-model="iot_device_port_tank_imperial.imperial_length"
										:label="`${$t('lang.imperial_length')} *`"
										:counter="showCounter(iot_device_port_tank_imperial.imperial_length, 'iot_device_port_tank_imperial.imperial_length')"
										:rules="ifValid('iot_device_port_tank_imperial.imperial_length')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('w')">
									<v-text-field v-model="iot_device_port_tank_imperial.imperial_width"
										:label="`${$t('lang.imperial_width')} *`"
										:counter="showCounter(iot_device_port_tank_imperial.imperial_width, 'iot_device_port_tank_imperial.imperial_width')"
										:rules="ifValid('iot_device_port_tank_imperial.imperial_width')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('h')">
									<v-text-field v-model="iot_device_port_tank_imperial.imperial_height"
										:label="`${$t('lang.imperial_height')} *`"
										:counter="showCounter(iot_device_port_tank_imperial.imperial_height, 'iot_device_port_tank_imperial.imperial_height')"
										:rules="ifValid('iot_device_port_tank_imperial.imperial_height')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('d')">
									<v-text-field v-model="iot_device_port_tank_imperial.imperial_diameter"
										:label="`${$t('lang.imperial_diameter')} *`" :counter="showCounter(iot_device_port_tank_imperial.imperial_diameter, 'iot_device_port_tank_imperial.imperial_diameter')
											" :rules="ifValid('iot_device_port_tank_imperial.imperial_diameter')"></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field v-model="iot_device_port_tank_imperial.imperial_sensor_offset"
										:label="`${$t('lang.imperial_sensor_offset')} *`" :counter="showCounter(
											iot_device_port_tank_imperial.imperial_sensor_offset,
											'iot_device_port_tank_imperial.imperial_sensor_offset'
										)
											" :rules="ifValid('iot_device_port_tank_imperial.imperial_sensor_offset')"></v-text-field>
								</v-flex>
							</v-layout>
							<v-layout row wrap v-else-if="current_user.unit_of_measure_display == 'metric'">
								<v-flex xs12>
									<v-text-field :focus="port_tank_dialog"
										v-model="iot_device_port_tank_metric.def_liters"
										:label="`${$t('lang.metric_size')} *`"
										:counter="showCounter(iot_device_port_tank_metric.def_liters, 'iot_device_port_tank_metric.def_liters')"
										:rules="ifValid('iot_device_port_tank_metric.def_liters')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('l')">
									<v-text-field v-model="iot_device_port_tank_metric.metric_length"
										:label="`${$t('lang.metric_length')} *`"
										:counter="showCounter(iot_device_port_tank_metric.metric_length, 'iot_device_port_tank_metric.metric_length')"
										:rules="ifValid('iot_device_port_tank_metric.metric_length')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('w')">
									<v-text-field v-model="iot_device_port_tank_metric.metric_width"
										:label="`${$t('lang.metric_width')} *`"
										:counter="showCounter(iot_device_port_tank_metric.metric_width, 'iot_device_port_tank_metric.metric_width')"
										:rules="ifValid('iot_device_port_tank_metric.metric_width')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('h')">
									<v-text-field v-model="iot_device_port_tank_metric.metric_height"
										:label="`${$t('lang.metric_height')} *`"
										:counter="showCounter(iot_device_port_tank_metric.metric_height, 'iot_device_port_tank_metric.metric_height')"
										:rules="ifValid('iot_device_port_tank_metric.metric_height')"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="currentFormula.includes('d')">
									<v-text-field v-model="iot_device_port_tank_metric.metric_diameter"
										:label="`${$t('lang.metric_diameter')} *`"
										:counter="showCounter(iot_device_port_tank_metric.metric_diameter, 'iot_device_port_tank_metric.metric_diameter')"
										:rules="ifValid('iot_device_port_tank_metric.metric_diameter')"></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field v-model="iot_device_port_tank_metric.sensor_offset"
										:label="`${$t('lang.metric_sensor_offset')} *`"
										:counter="showCounter(iot_device_port_tank_metric.sensor_offset, 'iot_device_port_tank_metric.sensor_offset')"
										:rules="ifValid('iot_device_port_tank_metric.sensor_offset')"></v-text-field>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn v-if="currTankField('id')" color="error" @mouseup.left="$refs.delete_tank.openDialog()">{{
						$t("lang.delete") }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="closePortTankDialog()">{{ $t("lang.cancel") }}</v-btn>
					<v-btn color="success" @mouseup.left="modifyTank()">{{ $t("lang.save") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>

		<bc-dialog :value="work_order_dialog" max-width="700">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.addWO") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="work_order_dialog"
						:dialog-status="work_order_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-form ref="work_order">
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12 sm6 align-self-start>
									<v-layout row wrap>
										<v-flex xs12 inner-flex>
											<v-text-field v-model="device.public_id" :label="$t('lang.node_id')"
												readonly>
												<template slot="append-outer">
													<bc-tooltip>
														<template slot="activator">
															<v-icon
																:color="work_order.warranty_repair == '1' ? 'success' : 'error'">{{
																	work_order.warranty_repair == "1" ? "check" : "close"
																}}</v-icon>
														</template>
														{{ $t("lang.warranty_repair") }} -
														{{ work_order.warranty_repair == "1" ? $t("lang.yes") :
															$t("lang.no") }}
													</bc-tooltip>
												</template>
											</v-text-field>
										</v-flex>
										<v-flex xs12 inner-flex>
											<v-textarea v-focus="work_order_dialog" v-model="work_order.return_address"
												:label="`${$t('lang.return_address')} *`" auto-grow rows="1"
												:rules="ifValid('work_orders.return_address')"></v-textarea>
										</v-flex>
										<v-flex xs12 inner-flex>
											<v-text-field v-model="work_order.inbound_tracking_number"
												:label="$t('lang.inbound_tracking_number')"
												:counter="showCounter(work_order.inbound_tracking_number, 'work_order.inbound_tracking_number')"
												:rules="ifValid('work_orders.inbound_tracking_number')"></v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 sm6 align-self-start>
									<v-layout row wrap>
										<v-flex xs12 inner-flex>
											<v-text-field v-model="work_order.contact_name"
												:label="`${$t('lang.contact_name')} *`"
												:counter="showCounter(work_order.contact_name, 'work_order.contact_name')"
												:rules="ifValid('work_orders.contact_name')"></v-text-field>
										</v-flex>
										<v-flex xs12 inner-flex>
											<bc-phone-input v-model="work_order.contact_phone"
												:phone_number="work_order.contact_phone"
												:code="work_order.country_iso_2" ref="phoneInput"
												input-name="contact_phone" input-label="contact_phone"
												:update-object="work_order"
												:rules="ifValid('work_orders.contact_phone')"
												:isRequired="false"></bc-phone-input>
										</v-flex>
										<v-flex xs12 inner-flex>
											<v-text-field v-model="work_order.contact_email"
												:label="`${$t('lang.contact_email')} *`"
												:counter="showCounter(work_order.contact_email, 'work_order.contact_email')"
												:rules="ifValid('work_orders.contact_email')"></v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12>
									<v-textarea v-model="work_order.reason_for_return"
										:label="`${$t('lang.reason_for_return')} *`" auto-grow rows="1"
										:rules="ifValid('work_orders.reason_for_return')"></v-textarea>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="work_order_dialog = false">{{ $t("lang.cancel") }}</v-btn>
					<v-btn color="success" @mouseup.left="add()">{{ $t("lang.save") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>

		<!-- signal graph  -->
		<bc-dialog :value="signalGraphDialog" fullscreen>
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.signal_quality") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-refresh @invoke-method="getSignalGraph()"></bc-btn-refresh>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="signalGraphDialog"
						:dialog-status="signalGraphDialog"></bc-btn-dialog-close>
				</v-card-title>
				<!-- signal chart goes here -->
				<v-card-text pa-0>
					<v-container pa-0>
						<v-layout row wrap>
							<v-flex xs12>
								<bc-charts chart-type="stock" :chart-data="signalData" stockName="Signal"></bc-charts>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</bc-dialog>
		<bc-dialog :value="tempGraphDialog" fullscreen>
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.temperature") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-refresh @invoke-method="getTemperatureGraph()"></bc-btn-refresh>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="tempGraphDialog"
						:dialog-status="tempGraphDialog"></bc-btn-dialog-close>
				</v-card-title>
				<!-- signal chart goes here -->
				<v-card-text pa-0>
					<v-container pa-0>
						<v-layout row wrap>
							<v-flex xs12>
								<bc-charts chart-type="stock" :chart-data="temperatureData"
									stockName="Temperature"></bc-charts>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</bc-dialog>
		<bc-dialog :value="deviceMonitor" fullscreen>
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.device_log") }} - {{ $isObjectSet(device) &&
						$isSet(device.public_id) ?
						device.public_id : "N/A" }}</span>
					<v-spacer></v-spacer>
					<!-- <bc-tooltip>
                        <template slot="activator">
                            <v-btn icon>
                                <v-icon>sync</v-icon>
                            </v-btn>
                        </template>
                        Sync Hologram
                    </bc-tooltip> -->
					<bc-btn-refresh @invoke-method="getLT14DeviceLogs()"></bc-btn-refresh>
					<!-- <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav> -->

					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="deviceMonitor"
						:dialog-status="deviceMonitor"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text class="pa-4">
					<v-flex xs12>
						<div v-for="(log, index) in lt14_device_logs" :key="log.device_log_id || index">
							<v-layout row wrap class="pa-3 grey lighten-4">
								<v-flex xs2>
									<div class="caption grey--text">Date</div>
									<div><strong>{{ log.server_date }}</strong></div>
								</v-flex>
								<v-flex xs1 class="text-xs-left">
									<div class="text-xs-center">
										<div class="caption grey--text">Signal</div>
										<div>
											<bc-tooltip>
												<template slot="activator">
													<v-icon :color="log.signal_quality_class"
														small>signal_cellular_alt</v-icon>
												</template>
												{{ log.signal_quality_text | capitalize }} ({{ log.signal_quality }})
											</bc-tooltip>
										</div>
									</div>
								</v-flex>
								<v-flex xs1 class="text-xs-left">
									<div class="text-xs-center">
										<div class="caption grey--text">Temp</div>
										<div v-if="log.temperature != null">
											{{ current_user.unit_of_measure == "0" ? log.temperature + "°F" :
												log.temperature + "°C"
											}}
										</div>
										<div v-else>--</div>
									</div>
								</v-flex>
								<v-flex xs1 class="text-xs-left">
									<div class="text-xs-center">
										<div class="caption grey--text">Battery</div>
										<div>{{ log.battery || "--" }}</div>
									</div>
								</v-flex>

							</v-layout>
							<v-flex xs12 v-if="log.ports && log.ports.length" class="mt-2">
								<v-layout row wrap>
									<v-flex v-for="port in log.ports" :key="port.port" xs6 sm4 md2 lg1 pa-1
										style="border-right: 1px solid #e0e0e0; max-width: 100px">
										<v-card flat class="pa-2 text-xs-center"
											style="background-color: transparent !important;">
											<div class="caption grey--text">Port {{ port.port }}</div>
											<div class="fw-bold">{{ port.last_raw_measurement || 0 }}</div>
										</v-card>

									</v-flex>
								</v-layout>
							</v-flex>
							<v-divider></v-divider>
						</div>
					</v-flex>
				</v-card-text>
			</v-card>
		</bc-dialog>

		<bc-dialog v-model="batteryGraphDialog" max-width="700" fullscreen>
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.battery_device") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-refresh @invoke-method="getBatteryGraph()"></bc-btn-refresh>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="batteryGraphDialog"
						:dialog-status="batteryGraphDialog"></bc-btn-dialog-close>
				</v-card-title>
				<!-- battery chart goes here -->
				<v-card-text>
					<v-container pa-0>
						<v-layout row wrap>
							<v-flex xs12>
								<bc-charts chart-type="stock" :chart-data="batteryData"></bc-charts>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</bc-dialog>

		<bc-dialog :value="portHistoryGraphDialog" fullscreen>
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.port_history") }}{{ portHistoryName != "" ? ` -
						${portHistoryName}` : ""
					}}</span>
					<v-spacer></v-spacer>
					<!-- <bc-btn-refresh @invoke-method="getportHistory()"></bc-btn-refresh> -->
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="portHistoryGraphDialog"
						:dialog-status="portHistoryGraphDialog"></bc-btn-dialog-close>
				</v-card-title>
				<!-- signal chart goes here -->
				<v-card-text pa-0>
					<v-layout row wrap pa-0>
						<v-flex xs12 pa-0>
							<bc-charts chart-type="stock" :chart-data="portHistoryData" stockName="History"></bc-charts>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</bc-dialog>

		<bc-dialog :value="tag_dialog">
			<v-card>
				<v-card-title>
					<span class="headline">{{
						device_tag_mode == "add"
							? $t("lang.manage_device_tags")
							: device_tag_mode == "create"
								? $t("lang.create_new_tag")
								: device_tag_mode == "modify"
									? $t("lang.manage_device_tags")
									: "nothing"
					}}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="tag_dialog"
						:dialog-status="tag_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text pa-0>
					<v-form ref="tags">
						<v-container grid-list-form>
							<v-layout row wrap v-if="device_tag_mode == 'add'">
								<v-flex xs12>
									<bc-autocomplete :focus="tag_dialog" v-model="current_tags" label="Tag(s)"
										:items="available_tags" item-value="tag_id" item-text="tag" multiple small-chips
										deletable-chips :rules="ifValid('tags.tag')"></bc-autocomplete>
								</v-flex>
							</v-layout>
							<v-layout row wrap v-else-if="device_tag_mode == 'create'">
								<v-flex xs12>
									<v-text-field v-focus="tag_dialog" v-model="edit_tag.tag"
										:label="`${$t('lang.tag')} *`"
										:counter="showCounter(edit_tag.tag, 'edit_tag.tag')"
										:rules="ifValid('tags.tag')"></v-text-field>
								</v-flex>
							</v-layout>
							<v-layout row wrap v-else-if="device_tag_mode == 'modify'">
								<v-flex xs12>
									<bc-autocomplete :focus="tag_dialog" v-model="current_tags" label="Tag(s)"
										:items="available_tags" item-value="tag_id" item-text="tag" multiple small-chips
										deletable-chips :rules="ifValid('tags.tag')"></bc-autocomplete>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<!-- <v-btn v-if="currTagField('tag_id')" color="error" @mouseup.left="$refs.remove_tags.openDialog()">{{ $t("lang.remove") }}</v-btn> -->
					<v-btn v-if="device_tag_mode != 'modify' && hasPerm('tags.create')" color="primary"
						@mouseup.left="device_tag_mode == 'add' ? (device_tag_mode = 'create') : (device_tag_mode = 'add')">{{
							device_tag_mode == "create" ? $t("lang.attach_existing") : $t("lang.add_new") }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="tag_dialog = false">{{ $t("lang.cancel") }}</v-btn>
					<v-btn v-if="device_tag_mode == 'add' || device_tag_mode == 'modify'" color="success"
						@mouseup.left="saveDeviceTag('existing')">{{
							$t("lang.save")
						}}</v-btn>
					<v-btn v-else-if="device_tag_mode == 'create'" color="success"
						@mouseup.left="saveDeviceTag('new')">{{
							$t("lang.create") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>
		<delete-confirmation-dialog ref="remove_tags" :heading="$t('lang.remove_tag')"
			:message="$t('lang.confirm_remove_message')"
			@onConfirm="modifyTag('delete', currTagField('tag_id'))"></delete-confirmation-dialog>

		<bc-dialog :value="mobile_network_dialog">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.mobile_network") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="mobile_network_dialog"
						:dialog-status="mobile_network_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text pa-0>
					<v-container pa-0 grid-list-form>
						<v-layout row wrap>
							<v-flex xs12 sm8 pa-0>
								<v-layout row wrap>
									<v-flex xs6> Last Network: </v-flex>
									<v-flex v-if="device.mobile" xs6 fw-semi-bold>
										{{ device && device.mobile ? device.mobile.last_network_used : "" }}
									</v-flex>
									<v-flex xs6> IP Address: </v-flex>
									<v-flex xs6 fw-semi-bold>
										{{ device ? device.ip_address : "" }}
									</v-flex>
									<v-flex xs6> Billing Data Usage: </v-flex>
									<v-flex v-if="device.mobile" xs6 fw-semi-bold>
										{{ device && device.mobile ? device.mobile.current_billing_data : "" }}
									</v-flex>
									<v-flex xs6> Last Connected: </v-flex>
									<v-flex v-if="device.mobile" xs6 fw-semi-bold>
										{{ device && device.mobile ? device.mobile.last_connected : "" }}
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 sm4 pa-0>
								<v-btn depressed color="success" class="mr-3 white--text px-3"
									@click="toggleSimState()">
									<span
										v-if="device && device.mobile && (device.mobile.sim_state == 'LIVE' || device.mobile.sim_state == 'PAUSED-USER')">{{
											device.mobile.sim_state == "LIVE" ? $t("lang.pause_caps") : $t("lang.activate")
										}}</span>
									<span v-else-if="device && device.mobile" class="mr-2">{{
										device.mobile.sim_state.includes("LIVE") ? "Activating" : "Pausing"
									}}</span>
									<v-progress-circular
										v-if="device && device.mobile && (device.mobile.sim_state || '').includes('PENDING')"
										indeterminate color="white"></v-progress-circular>
								</v-btn>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</bc-dialog>
		<!-- qrcode dialog  -->
		<v-dialog v-model="QrDialog" persistent max-width="320">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.device_code") }}</span>
					<v-spacer></v-spacer>
					<bc-modal-print :printDialog="printDialog" :show="true"></bc-modal-print>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="QrDialog"
						:dialog-status="QrDialog"></bc-btn-dialog-close>
				</v-card-title>
				<!-- qr code goes here -->
				<v-card-text>
					<v-container grid-list-form>
						<v-layout row wrap>
							<v-flex xs12>
								<div style="width: 100%; display: flex; justify-content: center; align-items: center">
									<vue-qrcode :value="`{ &quot;device_id&quot;: &quot;${device.device_id}&quot; }`"
										:width="$bp.xs ? 300 : 320" />
								</div>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="access_dialog" persistent max-width="400">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.access") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="access_dialog"
						:dialog-status="access_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-form>
						<v-layout row wrap>
							<v-flex xs12>
								<vue-perfect-scrollbar style="max-height: 500px">
									<v-list two-line>
										<template v-for="(person, index) in device_users">
											<v-list-tile :key="index" class="clickable"
												@click="goToPerson(person.people_id)">
												<v-list-tile-avatar>
													<img :src="person.photo" />
												</v-list-tile-avatar>
												<v-list-tile-content>
													<v-list-tile-title>{{ person.combined_name }}</v-list-tile-title>
													<v-list-tile-sub-title>{{ person.company }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
										</template>
									</v-list>
								</vue-perfect-scrollbar>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<bc-dialog :value="move_products_dialog" max-width="900">
			<v-card>
				<v-card-title>
					<span class="headline">Move Products</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="move_products_dialog"
						:dialog-status="move_products_dialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-form ref="move_products">
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12 v-if="devices.length > 0 && devicesFiltered.length > 0">
									<bc-autocomplete v-model="move_to_device_id" label="Move To"
										:items="devicesFiltered" item-value="device_id"
										item-text="public_id"></bc-autocomplete>
								</v-flex>
								<v-flex xs12 v-else>
									<span class="red--text fs-18"> No devices available to move products to. </span>
								</v-flex>
								<v-flex xs6 v-if="move_to_device_id != null">
									<v-text-field v-model="move_product_device_validation"
										:label="`Please Enter the Current Device #: ${device.public_id}`"></v-text-field>
								</v-flex>
								<v-flex xs6 v-if="move_to_device_id != null">
									<v-text-field v-model="move_product_new_device_validation"
										:label="`Please Enter the New Device #: ${devices.filter((obj) => obj.device_id == move_to_device_id)[0].public_id}`"></v-text-field>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="move_products_dialog = false">{{ $t("lang.cancel") }}</v-btn>
					<v-btn v-if="devices.length > 0 && devicesFiltered.length > 0" color="success"
						@mouseup.left="moveProducts()">Move</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>
		<bc-dialog :value="subscription_dialog">
			<v-card>
				<v-form ref="form_subscription">
					<v-card-title>
						<span class="headline">{{ subscription.id ? $t("lang.edit_subscription") :
							$t("lang.add_subscription")
						}}</span>
						<v-spacer></v-spacer>
						<bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeSubscriptionDialog"
							:dialog-status="subscription_dialog"></bc-btn-dialog-close>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12>
									<bc-autocomplete v-model="subscription.company_id" :label="$t('lang.company')"
										:items="company_options" item-value="company_id" item-text="company"
										:rules="ifValid('subscriptions.company_id')" append-icon="lock"
										:disabled="true"></bc-autocomplete>
								</v-flex>

								<v-flex xs12>
									<bc-select
										@change="subscription.amount = subscription_plans.find(plan => plan.plan_id == subscription.plan_id).amount"
										v-model="subscription.plan_id" :label="`${$t('lang.term_length')} *`"
										:items="subscription_plans" item-value="plan_id" item-text="term_months"
										:rules="ifValid('subscriptions.plan_id')">
										<!-- for the options should be plan_text - term_months -->
										<template v-slot:item="{ item }"> {{ item.description }}</template>
										<template v-slot:selection="{ item }"> {{ item.description }}</template>
									</bc-select>
								</v-flex>
								<v-flex xs12>
									<v-text-field :value="todaysDate" :label="`${$t('lang.period_start')}`" readonly
										disabled append-icon="hgi-solid hgi-square-lock-02"></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field :value="calculatedPeriodEnd" :label="`${$t('lang.period_end')}`"
										readonly disabled append-icon="hgi-solid hgi-square-lock-02"></v-text-field>
								</v-flex>
								<v-flex xs12 v-if="!device.distributor_id">
									<v-text-field v-model="subscription.amount" :label="`${$t('lang.amount')} *`"
										:counter="showCounter(subscription.amount, 'subscriptions.amount')"
										:rules="ifValid('subscriptions.amount')" prefix="$"></v-text-field>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-btn v-if="subscription.id" color="error"
							@mouseup.left="$refs.delete_subscriptions.openDialog()">{{
								$t("lang.delete") }}</v-btn>
						<v-spacer></v-spacer>
						<v-btn flat @mouseup.left="closeSubscriptionDialog()">{{ $t("lang.cancel") }}</v-btn>
						<v-btn color="success" @click="saveSubscriptions">{{ $t("lang.save") }}</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</bc-dialog>
		<bc-dialog v-if="device.ports != null && device.ports.length > 0" v-model="orderDialog" max-width="1000">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("lang.orders") }}</span>
					<v-spacer></v-spacer>
					<bc-btn-dialog-close @invoke-method="closeTransactionDocDialog()" dialog-model="orderDialog"
						:dialog-status="orderDialog"></bc-btn-dialog-close>
				</v-card-title>
				<v-card-text>
					<v-container pa-0>
						<v-layout row>
							<v-flex xs3 pr-4>
								<vue-perfect-scrollbar style="height: 500px">
									<v-list three-line>
										<template v-for="(item, index) in transaction_documents">
											<v-list-tile @click="selectOrder(item.document_id)"
												:style="{ backgroundColor: transaction_document.document_id == item.document_id ? '#f5f5f5' : '' }">
												<v-list-tile-content>
													<v-list-tile-title>{{ `Order #: ${item.document_id}`
													}}</v-list-tile-title>
													<v-list-tile-sub-title style="display: unset !important">
														<p style="margin-bottom: 0px !important">{{ item.date_created }}
														</p>
														<v-chip small :color="item.status_class" class="ma-0" disabled
															text-color="white">{{
																item.status
															}}</v-chip>
													</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider class="ma-0"
												v-if="index < transaction_documents.length - 1"></v-divider>
										</template>
									</v-list>
								</vue-perfect-scrollbar>
							</v-flex>
							<v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
							<v-flex xs9 pl-4>
								<h1 v-if="selected_order == null && show_new_order == false"
									style="justify-content: center; color: lightgray; height: 100%; display: flex; align-items: center">
									Please select an order to view details
								</h1>
								<v-form ref="transaction_document"
									v-if="selected_order != null || show_new_order == true">
									<v-layout row wrap v-if="device.entity_addresses">
										<v-flex xs6>
											<h3>
												{{ $t("lang.shipping_address_id") }}
											</h3>
											<v-flex v-if="device.entity_addresses[0].location_label">{{
												device.entity_addresses[0].location_label }}</v-flex>
											<v-flex><small>{{ device.entity_addresses[0].address1 }}</small></v-flex>
											<v-flex><small>{{
												`${device.entity_addresses[0].city ? device.entity_addresses[0].city
													+ "," :
													""} ${device.entity_addresses[0].state || ""
												} ${device.entity_addresses[0].zip_code || ""}`
													}}</small></v-flex>
										</v-flex>
										<v-flex xs6>
											<h3>{{ transaction_document.document_id ? `Order #:
												${transaction_document.document_id}` : "New Order" }}</h3>
											<v-chip v-if="transaction_document.document_id" small
												:color="transaction_document.status_class" class="ma-0 mb-2"
												style="width: fit-content" text-color="white" disabled>{{
													transaction_document.status }}</v-chip>
											<bc-date-picker
												:disabled="transaction_document.status_id == '26' || transaction_document.status_id == null ? false : true"
												class="mt-auto" v-model="transaction_document.due_date"
												:label="`${$t('lang.expected_delivery_date')} *`"
												:rules="ifValid('transaction_documents.due_date')"></bc-date-picker>
										</v-flex>
										<v-flex xs12><v-divider horizontal></v-divider></v-flex>
									</v-layout>

									<v-toolbar color="transparent" class="transaction-toolbar"
										style="box-shadow: unset !important" elevation="0">
										<v-toolbar-title class="ml-0">Products</v-toolbar-title>
										<v-spacer></v-spacer>
									</v-toolbar>
									<v-flex xs12>
										<vue-perfect-scrollbar style="height: 280px">
											<v-data-table :headers="orderHeaders"
												:items="transaction_document.transaction_document_details" hide-actions>
												<template slot="items" slot-scope="props">
													<tr>
														<td>
															{{
																device.ports.find(
																	(port) => port.product_id == props.item.product_id &&
																		port.sensor_type_id != 4
																).product_name
															}}
														</td>
														<td v-if="selected_order == null" class="text-center">{{
															props.item.available_capacity }}</td>
														<td>
															<v-text-field :disabled="transaction_document.status_id == '26' || transaction_document.status_id == null
																? false
																: true
																" v-model="props.item.quantity" :rules="ifValid('transaction_document_details.quantity')"></v-text-field>
														</td>
														<td class="text-center">
															<v-btn
																v-if="transaction_document.status_id == '26' || transaction_document.status_id == null"
																icon
																@click="removeProductFromTransaction(props.index)"><v-icon>delete</v-icon></v-btn>
														</td>
													</tr>
												</template>
												<template v-if="
													device.ports.filter(
														(port) =>
															!transaction_document.transaction_document_details.find(
																(detail) => detail.product_id == port.product_id
															)
													).length > 0 &&
													(transaction_document.status_id == '26' || transaction_document.status_id == null)
												" v-slot:footer>
													<td :colspan="transaction_doc_headers.length - 1">
														<bc-autocomplete placeholder="Select Product"
															v-model="selected_product" :items="device.ports.filter(
																(port) =>
																	!transaction_document.transaction_document_details.find(
																		(detail) => detail.product_id == port.product_id
																	)
															) || []
																" item-value="product_id" item-text="product_name">
														</bc-autocomplete>
													</td>
													<td colspan="1">
														<v-btn color="primary" icon @click="addProductToTransaction()"
															:disabled="selected_product == ''"><v-icon>add</v-icon></v-btn>
													</td>
												</template>
											</v-data-table>
										</vue-perfect-scrollbar>
									</v-flex>
								</v-form>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions v-if="device.entity_addresses != null">
					<v-btn v-if="show_new_order == false" color="primary" @click="addOrder()">Add Order</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat @mouseup.left="closeTransactionDocDialog()">{{ $t("lang.cancel") }}</v-btn>
					<v-btn v-if="selected_order != null && transaction_document.status_id == '26'" color="error"
						@click="deleteOrder(transaction_document.document_id)">Delete Order</v-btn>
					<v-btn
						v-if="(selected_order != null || show_new_order == true) && transaction_document.status_id == null"
						color="grey" style="color: white" @click="saveTransactionDocumentForm('draft')">{{
							$t("lang.save_as_draft") }}</v-btn>
					<v-btn
						v-if="hasPerm('logistics.update') && selected_order != null && transaction_document.status_id == '27'"
						color="warning" @click="saveTransactionDocumentForm('draft')">Recall Order</v-btn>
					<v-btn v-if="
						(selected_order != null || show_new_order == true) &&
						(transaction_document.status_id == '26' || transaction_document.status_id == null)
					" color="success" @click="saveTransactionDocumentForm('submit')">{{ $t("lang.submit_order") }}</v-btn>
				</v-card-actions>
				<v-card-actions v-else>
					<v-alert class="w-100" :value="true" type="warning"> You can create an order once the device has an
						address
						assigned to it. </v-alert>
				</v-card-actions>
			</v-card>
		</bc-dialog>
		<bc-dialog :value="no_account_dialog" max-width="400">
			<v-card>
				<v-card-text class="pt-4" style="margin: 0px !important">
					<p class="mb-0"><strong>Please attach this device to a company before adding a
							subscription.</strong></p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="no_account_dialog = false">{{ $t("lang.ok") }}</v-btn>
				</v-card-actions>
			</v-card>
		</bc-dialog>
		<delete-confirmation-dialog ref="delete_device" :heading="$t('lang.delete_device')"
			:message="$t('lang.confirm_delete_message')" @onConfirm="removeDevice()">
			<v-text-field v-model="delete_device_validation"
				:label="`Please Enter the Current Device #: ${device.public_id}`"></v-text-field></delete-confirmation-dialog>
		<delete-confirmation-dialog ref="delete_tag_from_device" :heading="$t('lang.delete_tag_from_device')"
			:message="$t('lang.confirm_delete_tag_from_device_message')"
			@onConfirm="removeTagFromDevice()"></delete-confirmation-dialog>
		<delete-confirmation-dialog ref="reprovision" :heading="$t('lang.reprovision')"
			:message="$t('lang.reprovision_device')" @onConfirm="reprovisionDevice()" :cancel_delete="false">
			<v-text-field v-model="reprovision_validation"
				:label="`Please Enter the Current Device #: ${device.public_id}`"></v-text-field></delete-confirmation-dialog>
		<delete-confirmation-dialog v-if="current_port" ref="delete_port"
			:heading="$t('lang.delete_port') + ' ' + currPortField('product_name')"
			:message="$t('lang.confirm_delete_message')" @onConfirm="deletePort()"></delete-confirmation-dialog>
		<delete-confirmation-dialog v-if="current_port && current_port.tank_specs" ref="delete_tank"
			:heading="$t('lang.delete_tank') + ' #' + (current_port.tank_specs.findIndex((tank) => tank.id == currTankField('id')) + 1)"
			:message="$t('lang.confirm_delete_message')" @onConfirm="deletePortTank()"></delete-confirmation-dialog>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import VueQrcode from "vue-qrcode";
import { store } from "Store/store";
import Vue from "vue";
import phpUnserialize from "phpunserialize";

export default {
	components: {
		VueQrcode,
	},
	data() {
		return {
			device: {},
			device_company_id: null,
			attach_tag_id: null,
			new_tag: false,
			all_tags: [],
			search: null,
			showError: false,
			QrDialog: false,
			signalGraphDialog: false,
			validWorkOrder: false,
			tag_dialog: false,
			work_order_dialog: false,
			move_products_dialog: false,
			move_to_device_id: null,
			mobile_network_dialog: false,
			menu_purchase_date: false,
			iot_device_dialog: false,
			port_dialog: false,
			public_display: null,
			device_id: null,
			menu_pour_date: false,
			customers: null,
			printDialog: false,
			firmware: null,
			iot_device: {
				company_id: "",
				warranty_period: "",
				purchase_date: "",
				device_type_id: "",
				record_interval: "",
				label: "",
				mobile_provider_id: "",
				firmware_version_id: "",
				status: "",
				surge_protection: "",
			},
			iot_device_port: {
				device_ports_id: "",
				port_number: "",
				product_id: "",
				tank_type_id: "",
				sensor_type_id: "",
				reorder_yellow: "",
				reorder_red: "",
				tank_specs: [],
			},
			iot_device_port_tank_metric: {
				device_ports_id: "",
				def_liters: "",
				metric_height: "",
				metric_diameter: "",
				metric_width: "",
				metric_length: "",
				sensor_offset: "",
			},
			iot_device_port_tank_imperial: {
				device_ports_id: "",
				def_us_gallons: "",
				imperial_height: "",
				imperial_diameter: "",
				imperial_width: "",
				imperial_length: "",
				imperial_sensor_offset: "",
			},
			iot_device_port_tank: {
				device_ports_id: "",
				volumme: "",
				height: "",
				diameter: "",
				width: "",
				length: "",
				sensor_offset: "",
			},
			edit_tag: {
				company_id: "",
				tag: "",
			},
			current_tag: null,
			current_port: null,
			device_type: [{ value: "1", text: "LT14" }],
			record_intervals: [
				{ value: "10", text: "10 Minutes (For Testing Only)" },
				{ value: "60", text: "1 Hour" },
				{ value: "120", text: "2 Hours" },
				{ value: "180", text: "3 Hours" },
				{ value: "240", text: "4 Hours (Default)" },
				{ value: "300", text: "5 Hours" },
				{ value: "360", text: "6 Hours" },
				{ value: "420", text: "7 Hours" },
				{ value: "480", text: "8 Hours" },
				{ value: "540", text: "9 Hours" },
				{ value: "600", text: "10 Hours" },
				{ value: "680", text: "11 Hours" },
				{ value: "740", text: "12 Hours" },
				{ value: "1440", text: "24 Hours" },
			],
			warranty_period: [{ value: "1", text: this.$t("lang.one_year") }],
			mobile_providers: [],
			surge_protection: [
				{ value: "0", text: this.$t("lang.no") },
				{ value: "1", text: this.$t("lang.yes") },
			],
			signalData: null,
			portHistoryData: null,
			temperatureData: null,
			status: [
				{ value: "new", text: this.$t("lang.new") },
				{ value: "active", text: this.$t("lang.active") },
				{ value: "suspended", text: this.$t("lang.suspended") },
				{ value: "retired", text: this.$t("lang.retired") },
			],
			dbGetDevice: _.debounce(this.getDevice, 1500, {
				maxWait: 1500,
				leading: true,
				trailing: false,
			}),
			work_order: {
				device_id: "",
				inbound_tracking_number: "",
				reason_for_return: "",
				return_address: "",
				contact_name: "",
				contact_phone: "",
				contact_phone_formatted: "",
				contact_email: "",
				wo_requested_by: "1",
				warranty_repair: "0",
				country_iso_2: "",
			},
			initial_wo: null,
			metric_spec_headers: [
				{ text: "", sortable: false, align: "center", value: "id" },
				{
					text: this.$t("lang.metric_size"),
					sortable: false,
					value: "def_us_gallons",
				},
				{
					text: this.$t("lang.metric_length"),
					sortable: false,
					formula: true,
					formula_val: "l",
					value: "metric_length",
				},
				{
					text: this.$t("lang.metric_width"),
					sortable: false,
					formula: true,
					formula_val: "w",
					value: "metric_width",
				},
				{
					text: this.$t("lang.metric_height"),
					sortable: false,
					formula: true,
					formula_val: "h",
					value: "metric_height",
				},
				{
					text: this.$t("lang.metric_diameter"),
					sortable: false,
					formula: true,
					formula_val: "d",
					value: "metric_diameter",
				},
				{
					text: this.$t("lang.metric_sensor_offset"),
					sortable: false,
					value: "sensor_offset",
				},
				{
					text: this.$t("lang.last_edit"),
					sortable: false,
				},
				{ text: "", sortable: false, align: "right" },
			],
			imperial_spec_headers: [
				{ text: "", sortable: false, align: "center", value: "id" },
				{
					text: this.$t("lang.imperial_size"),
					sortable: false,
					value: "def_us_gallons",
				},
				{
					text: this.$t("lang.imperial_length"),
					sortable: false,
					formula: true,
					formula_val: "l",
					value: "imperial_length",
				},
				{
					text: this.$t("lang.imperial_width"),
					sortable: false,
					formula: true,
					formula_val: "w",
					value: "imperial_width",
				},
				{
					text: this.$t("lang.imperial_height"),
					sortable: false,
					formula: true,
					formula_val: "h",
					value: "imperial_height",
				},
				{
					text: this.$t("lang.imperial_diameter"),
					sortable: false,
					formula: true,
					formula_val: "d",
					value: "imperial_diameter",
				},
				{
					text: this.$t("lang.imperial_sensor_offset"),
					sortable: false,
					value: "sensor_offset",
				},
				{
					text: this.$t("lang.last_edit"),
					sortable: false,
				},
				{ text: "", sortable: false, align: "right" },
			],
			adjusted_headers: [],
			device_logs: [],
			warranty_status: 0,
			sim_loader: false,
			refresh_timer: "",
			port_tank_dialog: false,
			current_tank: {},
			port_headers: [
				{ text: this.$t("lang.product_name"), sortable: false, width: "20%" },
				{ text: this.$t("lang.port_number"), sortable: false, width: "2%", align: "center" },
				{ text: "", sortable: false, width: "2%", align: "center" },
				{ text: "", sortable: false, width: "50%", align: "center" },
				{ text: "", width: "1%", sortable: false },
			],
			portHistoryGraphDialog: false,
			tempGraphDialog: false,
			delete_tag_id: null,
			subscription_dialog: false,
			subscription: {
			},
			reprovision_validation: "",
			delete_device_validation: "",
			deviceMonitor: false,
			batteryGraphDialog: false,
			batteryData: null,
			move_product_device_validation: "",
			move_product_new_device_validation: "",
			device_tag_mode: "add",
			current_tags: [],
			test_data: "",
			device_monitor_headers: [
				{ text: this.$t("lang.pin_1"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_2"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_3"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_4"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_5"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_6"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_7"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_8"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_9"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_10"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_11"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_12"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_13"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_14"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.pin_15"), sortable: false, width: "10%", align: "center" },
				{ text: this.$t("lang.pin_16"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.signal"), sortable: false, width: "5%", align: "center" },
				{ text: this.$t("lang.date"), sortable: false, width: "15%", align: "center" },
			],
			current_header_data: null,
			portHistoryName: "",
			formatLang: "en-EN",
			formatStyle: "currency",
			formatCurrency: "USD",
			access_dialog: false,
			items: [
				{ name: "John Doe", email: "john.doe@gmail.com", avatar: "https://picsum.photos/200" },
				{ name: "Jane Doe", email: "jane.doe@gmail.com", avatar: "https://picsum.photos/200" },
				{ name: "John Smith", email: "john.smith@gmail.com", avatar: "https://picsum.photos/200" },
				{ name: "Jane Smith", email: "jane.smith@gmail.com", avatar: "https://picsum.photos/200" },
			],
			device_users: [],
			filter: {
				search: "",
				status: "active",
				company_id: null,
				device_type_id: null,
				tags: [],
				page_size: 0,
				page_num: 0,
				connection_status: "",
			},
			dataSource: {
				chart: {
					caption: "",
					subCaption: "",
					xAxisName: "Country",
					yAxisName: "Reserves (MMbbl)",
					numberSuffix: "K",
					theme: "fusion",
				},
				data: [
					{
						label: "Venezuela",
						value: "290",
					},
					{
						label: "Saudi",
						value: "260",
					},
					{
						label: "Canada",
						value: "180",
					},
					{
						label: "Iran",
						value: "140",
					},
					{
						label: "Russia",
						value: "115",
					},
					{
						label: "UAE",
						value: "100",
					},
					{
						label: "US",
						value: "30",
					},
					{
						label: "China",
						value: "30",
					},
				],
			},
			transaction_doc_headers: [],
			orderDialog: false,
			transaction_document: {
				device_id: "",
				document_type: "order",
				document_date: "",
				due_date: "",
				comments: "",
				transaction_document_details: [],
			},
			selected_product: "",
			transaction_documents: [],
			selected_order: null,
			show_new_order: false,
			selectedTankSpec: null,
			manu_tank_specs: [],
			no_account_dialog: false,
		};
	},
	beforeRouteUpdate(to, from, next) {
		const id = `${to.params.id}`;

		if (id !== "undefined") {
			this.$store
				.dispatch("fetchDevice", {
					id: id,
				})
				.then((data) => {
					if (typeof data !== "undefined" && data.device) {
						this.device = this.assignObj2(data.device, this.rules_devices);
						this.device_company_id = this.device.company_id;

						this.$store.dispatch("fetchSetting", {
							url: "options?slug=device_status&sort_by=2",
							method: "get",
							stateProperty: "device_status_options",
							dataProperty: "options",
							commit: true,
						});

						this.finishLoader();
						next();
					} else {
						next({ name: "devices", replace: true });
					}
				});
		} else {
			this.finishLoader();
			next();
		}
	},
	beforeRouteEnter(to, from, next) {
		const id = `${to.params.id}`;

		if (id !== "undefined") {
			store
				.dispatch("fetchDevice", {
					id: id,
				})
				.then((data) => {
					if (typeof data !== "undefined" && data.device) {
						next((vm) => {
							vm.device = vm.assignObj2(data.device, vm.rules_devices);
							vm.device_company_id = vm.device.company_id;

							store.dispatch("fetchSetting", {
								url: "options?slug=device_status&sort_by=2",
								method: "get",
								stateProperty: "device_status_options",
								dataProperty: "options",
								commit: true,
							});

							vm.finishLoader();
						});
					} else {
						next({ name: "devices", replace: true });
					}
				});
		} else {
			next((vm) => {
				vm.finishLoader();
			});
		}
	},
	computed: {
		...mapState({
			tank_types: (state) => state.tank_types.tank_types,
			entity_addresses: (state) => state.devices.entity_addresses,
			devices: (state) => state.devices.device_options,
			ports: (state) => state.devices.ports,
			device_tags: (state) => state.devices.device_tags,
			rules_devices: (state) => state.devices.rules_devices,
			rules_work_orders: (state) => state.work_orders.rules_work_orders,
			rules_tags: (state) => state.tags.rules_tags,
			rules_iot_device_port: (state) => state.validation.rules_iot_device_port,
			rules_iot_device_port_tank: (state) => state.validation.rules_iot_device_port_tank,
			rules_tank_spec: (state) => state.validation.rules_tank_spec,
			tank_products: (state) => state.tank_products.tank_products,
			sensor_types: (state) => state.sensor_types.sensor_types,
			device_types: (state) => state.devices.device_types,
			customer_options: (state) => state.customers.customer_options,
			rules_subscriptions: (state) => state.subscriptions.rules_subscriptions,
			tags: (state) => state.tags.tag_options,
			rules_iot_device_port_tank_metric: (state) => state.devices.rules_iot_device_port_tank_metric,
			rules_iot_device_port_tank_imperial: (state) => state.devices.rules_iot_device_port_tank_imperial,
			lt14_device_logs: (state) => state.devices.lt14_device_logs,
			lt14_device_log_page: (state) => state.devices.lt14_device_log_page,
			default_filter: (state) => state.devices.devices_filter,
			rules_transaction_documents: (state) => state.transaction_documents.rules_transaction_documents,
			rules_transaction_document_details: (state) => state.transaction_documents.rules_transaction_documents.transaction_document_details,
			subscription_plans: (state) => state.subscription_plans.subscription_plans,
			company_options: (state) => state.companies.company_options,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
		hasPermission() {
			return this.hasPerm("devices.update", this.device.company_id);
		},
		orderHeaders() {
			let headers = [{ text: this.$t("lang.product"), sortable: false, width: "70%" }];

			if (this.selected_order == null) {
				headers.push({ text: this.$t("lang.available_capacity"), sortable: false, width: "10%", align: "center" });
			}

			headers.push({ text: this.$t("lang.order_quantity"), sortable: false, width: "28%" }, { text: "", sortable: false, width: "2%" });

			return headers;
		},
		fullMobileList() {
			let fullList = [
				{
					title: this.$t("lang.move_products"),
					action: "openMoveProductsDialog",
					dialog_model: "move_products_dialog",
					status: true,
					perms: ["devices.move"],
				},
				{
					title: this.$t("lang.addWO"),
					action: "control_dialog",
					dialog_model: "work_order_dialog",
					status: true,
					perms: ["work_orders.create"],
				},
				{
					title: this.$t("lang.reprovision"),
					action: "openDialog",
					ref: "reprovision",
					perms: ["devices.reprovision"],
				},
			];
			if (this.device && this.device.mobile && this.hasPerm("sims.update_state")) {
				fullList.unshift({
					title: this.$t("lang.mobile_network"),
					action: "control_dialog",
					dialog_model: "mobile_network_dialog",
					status: true,
					perms: ["sims.update_state"],
				});
			}
			fullList.unshift(
				{
					title: this.$t("lang.device_log"),
					action: "monitorDevice",
					perms: ["devices.monitor"],
				},
				{
					title: this.$t("lang.add_subscription"),
					action: "openSubscriptionDialog",
					perms: ["subscriptions.create"],
				},
				{
					title: this.$t("lang.access"),
					action: "openAccessDialog",
					dialog_model: "access_dialog",
					status: true,
					ref: "access_dialog",
					perms: ["devices.update"],
				}
			);
			if (this.$bp.smAndDown) {
				fullList.unshift(
					{
						title: this.$t("lang.modify_device"),
						action: "openDeviceDialog",
						perms: ["devices.update"],
					},
					{
						title: this.$t("lang.add_port"),
						action: "openPortDialog",
					},

					{
						title: this.$t("lang.refresh"),
						action: "dbGetDevice",
						params: [true],
					}
				);
			}
			if (store.getters.user_is_dev) {
				fullList[fullList.length] = {
					title: this.$t("lang.delete_device"),
					action: "openDialog",
					ref: "delete_device",
				};
			}
			return fullList;
		},
		todaysDate() {
			return new Date().toISOString().split("T")[0];
		},
		calculatedPeriodEnd() {
			if (!this.subscription.plan_id) {
				return "";
			}

			const selectedPlan = this.subscription_plans.find((plan) => plan.plan_id === this.subscription.plan_id);
			if (!selectedPlan) {
				return "";
			}

			const startDate = new Date(this.todaysDate + "T00:00:00");
			const termMonths = parseInt(selectedPlan.term_months);

			let endDate = new Date(startDate);
			endDate.setMonth(endDate.getMonth() + termMonths);

			if (startDate.getDate() !== 1) {
				endDate.setDate(1);
				endDate.setMonth(endDate.getMonth() + 1);
			} else {
				endDate.setDate(1);
			}

			const year = endDate.getFullYear();
			const month = String(endDate.getMonth() + 1).padStart(2, "0");
			const day = String(endDate.getDate()).padStart(2, "0");

			return `${year}-${month}-${day}`;
		},
		// WIP
		validTag() {
			return true; //this.search ? this.$r.emailRegex.test(this.search) : true;
		},
		currTagField() {
			return (field) => {
				return this.current_tag && field && this.current_tag[field] ? this.current_tag[field] : "";
			};
		},
		currPortField() {
			return (field) => {
				return this.current_port && field && this.current_port[field] ? this.current_port[field] : "";
			};
		},
		currTankField() {
			return (field) => {
				return this.current_tank && field && this.current_tank[field] ? this.current_tank[field] : "";
			};
		},
		available_tags() {
			// add the tag objects from the iot_device_tags array to the tag_options array
			let tags = [];
			if (this.device && this.device.iot_device_tags) {
				this.device.iot_device_tags.forEach((tag) => {
					tags.push(tag);
				});
			}
			return [...this.tags, ...tags];
		},
		currentTags() {
			if (this.device.iot_device_tags == null) this.device.iot_device_tags = [];
			return this.device && this.device.iot_device_tags != null ? this.device.iot_device_tags : [];
		},
		currTankTypeField() {
			return (field) => {
				let index =
					this.tank_types && this.iot_device_port.tank_type_id
						? this.tank_types.findIndex((obj) => obj["tank_type_id"] == this.iot_device_port.tank_type_id)
						: -1;
				let port = index != -1 ? this.tank_types[index] : null;
				return field && port ? port[field] : "";
			};
		},
		currentFormula() {
			if (this.iot_device_port.tank_type_id != 0 && this.tank_types)
				this.current_port.formula = this.tank_types.find((obj) => obj.tank_type_id == this.iot_device_port.tank_type_id).formula;
			return this.current_port && this.current_port.formula ? this.current_port.formula : [];
		},
		currentPortTankSpecs() {
			return this.current_port ? this.current_port.tank_specs : [];
		},
		portNumberOptions() {
			const MAX_PORTS = this.device.num_ports;
			let portNumbers = [];
			if (this.device.ports) {
				for (let i = 1; i <= MAX_PORTS; i++) {
					let index = this.device.ports.findIndex((obj) => obj["port_number"] == i);
					if (index == -1) {
						portNumbers.push(i);
					}
				}
			} else {
				for (let i = 1; i <= MAX_PORTS; i++) {
					portNumbers.push(i);
				}
			}

			if (this.current_port && this.current_port.port_number) {
				portNumbers.push(this.current_port.port_number);
			}
			return portNumbers;
		},
		devicesFiltered() {
			return this.devices
				? this.devices.filter((d) => (d.company_id == this.device.company_id && d.device_id != this.device.device_id) || d.company_id == null)
				: [];
		},
	},
	methods: {
		...mapActions([
			"fetchPortHistoryGraph",
			"fetchCustomers",
			"saveSubscription",
			"saveWorkOrder",
			"fetchTags",
			"fetchDevice",
			"deleteDevice",
			"fetchSignalStrengthGraph",
			"saveDevice",
			"fetchDeviceTypes",
			"addDeviceTag",
			"removeDeviceTag",
			"fetchBatteryGraph",
			"reproviseDevice",
			"saveTag",
			"saveDevicePort",
			"saveDevicePortTank",
			"removeDevicePortTank",
			"removeDevicePort",
			"fetchTemperatureGraph",
			"saveProductMove",
			"fetchLT14DeviceLogs",
			"fetchDeviceUsers",
			"saveTransactionDocument",
			"fetchTransactionDocuments",
			"fetchTransactionDocument",
			"deleteTransactionDocument",
			"fetchMobileProviders",
			"fetchTankManufacturerSpecs",
			"fetchSubscriptionPlans",
			"fetchCompanies",
		]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader", "updateTagOptions"]),
		openPortTank(tank) {
			this.$nextTick(() => {
				this.fetchTankManufacturerSpecs({ id: 2, body: { options: 1, tank_type_id: this.current_port.tank_type_id } }).then((data) => {
					if (data && data.tank_manufacturers_specs) {
						this.manu_tank_specs = data.tank_manufacturers_specs;
					}
				});
				this.port_tank_dialog = true;
				this.current_tank = tank ? tank : {};
				if (this.current_user.unit_of_measure_display == "imperial") {
					if (this.current_tank) {
						this.assignObj(this.iot_device_port_tank_imperial, this.current_tank, this.rules_iot_device_port_tank_imperial);
					}

					this.iot_device_port_tank_imperial.device_ports_id = this.current_port.device_ports_id;
				} else {
					if (this.current_tank) {
						this.assignObj(this.iot_device_port_tank_metric, this.current_tank, this.rules_iot_device_port_tank_metric);
					}

					this.iot_device_port_tank_metric.device_ports_id = this.current_port.device_ports_id;
					if (!this.iot_device_port_tank_metric.sensor_offset) {
						// replace with metric_sensor_offset
						this.iot_device_port_tank_metric.sensor_offset = this.iot_device_port_tank_metric.metric_sensor_offset;
						delete this.iot_device_port_tank_metric.metric_sensor_offset;
					}
				}
			});
		},
		adjustHeaders(port) {
			if (this.current_user.unit_of_measure_display == "metric" && this.current_port != null) {
				let _headers = [...this.metric_spec_headers];
				this.$nextTick(() => {
					if (this.currentFormula && this.currentFormula.length > 0) {
						this.metric_spec_headers.forEach((h, i) => {
							if (h.formula && !this.currentFormula.includes(h.formula_val)) {
								let indexOfObject = _headers.findIndex((obj) => obj.formula_val == h.formula_val);
								_headers.splice(indexOfObject, 1);
							}
						});
					} else {
						_headers = _headers.filter((h) => !h.formula);
					}
					this.adjusted_headers = _headers;
				});
			} else if (this.current_user.unit_of_measure_display == "imperial" && this.current_port != null) {
				let _headers = [...this.imperial_spec_headers];
				this.$nextTick(() => {
					if (this.currentFormula && this.currentFormula.length > 0) {
						this.imperial_spec_headers.forEach((h, i) => {
							if (h.formula && !this.currentFormula.includes(h.formula_val)) {
								let indexOfObject = _headers.findIndex((obj) => obj.formula_val == h.formula_val);
								_headers.splice(indexOfObject, 1);
							}
						});
					} else {
						_headers = _headers.filter((h) => !h.formula);
					}
					this.adjusted_headers = _headers;
				});
			}
		},
		// WIP
		remove(item) {
			const index = this.email_info.to.indexOf(item.primary_email_address);
			if (index >= 0) {
				this.displayed_email.splice(index, 1);
				this.email_info.to.splice(index, 1);
			}
		},
		showTag(toggle_edit = false) {
			if (toggle_edit == true) {
				this.device_tag_mode = "modify";
			}
			// set this.current_tags to an array of tag_ids that are currently attached to this device
			this.current_tags = this.device.iot_device_tags ? this.device.iot_device_tags.map((tag) => tag.tag_id) : [];
			this.tag_dialog = true;
		},
		monitorDevice() {
			this.$store.commit("toggleModalLoader", true);
			this.fetchLT14DeviceLogs({ body: { device_id: this.device.device_id } }).then((data) => {
				this.$store.commit("toggleModalLoader", false);
			});
			this.deviceMonitor = true;
		},
		openSignalGraph() {
			this.signalGraphDialog = true;
			this.getSignalGraph();
		},
		openTemperatureGraph() {
			this.tempGraphDialog = true;
			this.getTemperatureGraph();
		},
		add() {
			this.$store.commit("validationOn");

			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("work_order")) {
					let body = this.prepForm(this.work_order, this.rules_work_orders);
					body["device_id"] = this.device.device_id;
					this.saveWorkOrder({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							this.toggleModalLoader(false);
							this.work_order_dialog = false;
						} else {
						}
					});
				}
			});
		},
		getSignalGraph() {
			this.$store.commit("toggleModalLoader", true);
			this.fetchSignalStrengthGraph({ id: this.device.device_id }).then((data) => {
				if (data.signal_strength_graph) {
					this.signalData = data.signal_strength_graph;
				}
				this.$store.commit("toggleModalLoader", false);
			});
		},
		getTemperatureGraph() {
			this.$store.commit("toggleModalLoader", true);
			this.fetchTemperatureGraph({ id: this.device.device_id }).then((data) => {
				if (data.temperature_graph) {
					this.temperatureData = data.temperature_graph;
				}
				this.$store.commit("toggleModalLoader", false);
			});
		},
		getDevice(status = true) {
			if (status) this.startLoader();
			this.fetchDevice({ id: this.device.device_id })
				.then((data) => {
					if (typeof data === "undefined" || !data.device) {
						this.$router.push({ name: "devices" });
					}

					this.work_order.warranty_repair = data.device.warranty_period;

					this.work_order.device_id = this.device_id;
					this.assignObj(this.device, data.device);
					this.assignObj(this.iot_device, data.device);

					if (this.current_port) {
						this.current_port = JSON.parse(
							JSON.stringify(this.device.ports.find((port) => port.device_ports_id == this.current_port.device_ports_id))
						);
						this.iot_device_port = {
							device_ports_id: this.current_port.device_ports_id,
							port_number: this.current_port.port_number,
							product_id: this.current_port.product_id,
							tank_type_id: this.current_port.tank_type_id,
							sensor_type_id: this.current_port.sensor_type_id,
							reorder_yellow: this.current_port.reorder_yellow,
							reorder_red: this.current_port.reorder_red,
							tank_specs: this.current_port.tank_specs ? this.current_port.tank_specs : [],
						};
						if (!this.current_port.tank_specs || this.current_port.tank_specs == undefined) {
							this.current_port.tank_specs = [];
						}
					}

					this.public_display = data.device.public_id;
					this.initial_wo = { ...this.work_order };

					if (this.device.company_id) {
						this.fetchTags({ body: { options: 1, company_id: this.device.company_id } });
					} else {
						this.$store.commit("updateTagOptions", []);
					}

					if (!data.device.mobile) return;

					this.iot_device.mobile_provider_id = data.device.mobile_provider_id;
					if (this.refresh_timer && !(data.device.mobile.sim_state || "").includes("PENDING")) {
						clearInterval(this.refresh_timer);
						this.createAlert("success", data.device.mobile.sim_state.includes("LIVE") ? "sim_activated" : "sim_paused");
					} else if (!this.refresh_timer && (data.device.mobile.sim_state || "").includes("PENDING")) {
						this.startDeviceRefresh();
					}
				})
				.finally(() => {
					this.$store.commit("toggleModalLoader", false);
					this.iot_device_dialog = false;
					this.$store.commit("validationOff");
					this.finishLoader(status);
				});
		},
		getDeviceLogs() {
			this.$store
				.dispatch("fetchDevices", {
					url: `devices/${this.device_id}/log`,
					method: "get",
				})
				.then((data) => {
					this.device_logs = data.device_logs;
				});
		},
		getFirmware() {
			this.$store
				.dispatch("fetchFirmwareVersion", {
					url: "firmware",
					method: "get",
					stateProperty: "firmware_versions",
					commit: true,
				})
				.then((data) => {
					if (typeof data !== "undefined") {
						this.firmware = data.firmware_versions;
					}
				});
		},
		clear() {
			this.$refs.form.reset();
		},
		openDeviceDialog() {
			if (this.firmware == null) {
				this.getFirmware();
			}
			this.iot_device_dialog = true;
		},
		modifyDevice() {
			this.$store.commit("validationOn");
			this.$nextTick(() => {
				if (this.validateForm("iot_device")) {
					let body = this.prepForm(this.device, this.rules_devices);
					body["device_id"] = this.device.device_id;
					body["company_id"] = this.device_company_id;
					this.$store.commit("toggleModalLoader", true);
					this.saveDevice({ body: body }).then((data) => {
						if (!data || data.code != "200") {
							this.$store.commit("toggleModalLoader", false);
							return;
						}

						this.$store.commit("toggleModalLoader", false);
						this.iot_device_dialog = false;
						this.getDevice(false);
					});
				}
			});
		},
		removeDevice() {
			if (this.delete_device_validation != this.device.public_id) {
				Vue.notify({
					group: "loggedIn",
					type: "error",
					text: "The Device Number you entered is incorrect. Please try again.",
				});
			} else {
				this.deleteDevice({ id: this.device.device_id }).then((data) => {
					if (data && data.code == "200") {
						this.$router.push({ name: "devices" });
					}
				});
			}
		},
		modifyTank() {
			if (this.current_user.unit_of_measure_display == "imperial") {
				// if (this.current_tank != null) this.iot_device_port_tank_imperial.id = this.current_tank.id;
				this.iot_device_port_tank_imperial.id = this.current_tank != null ? this.current_tank.id : null;
				this.iot_device_port_tank_imperial.tank_type_id = this.current_port.tank_type_id;
				this.iot_device_port_tank_imperial.unit_of_measure = this.current_user.unit_of_measure_display;

				// Remove any imperial fields that are empty that start with imperial_
				Object.keys(this.iot_device_port_tank_imperial).forEach((key) => {
					if (key.includes("imperial_") && (this.iot_device_port_tank_imperial[key] == "" || this.iot_device_port_tank_imperial[key] == null)) {
						delete this.iot_device_port_tank_imperial[key];
					}
				});
			} else {
				// if (this.current_tank != null) this.iot_device_port_tank_metric.id = this.current_tank.id;
				this.iot_device_port_tank_metric.id = this.current_tank != null ? this.current_tank.id : null;
				this.iot_device_port_tank_metric.tank_type_id = this.current_port.tank_type_id;
				this.iot_device_port_tank_metric.unit_of_measure = this.current_user.unit_of_measure_display;

				// Remove any metric fields that are empty that start with metric_
				Object.keys(this.iot_device_port_tank_metric).forEach((key) => {
					if (key.includes("metric_") && (this.iot_device_port_tank_metric[key] == "" || this.iot_device_port_tank_metric[key] == null)) {
						delete this.iot_device_port_tank_metric[key];
					}
				});
			}

			if (this.current_user.unit_of_measure_display == "metric") {
				// rename sensor_offset to metric_sensor_offset
				this.iot_device_port_tank_metric.metric_sensor_offset = this.iot_device_port_tank_metric.sensor_offset;
				delete this.iot_device_port_tank_metric.sensor_offset;
			}
			this.$store.commit("validationOn");
			this.$nextTick(() => {
				if (this.validateForm("iot_device_port_tank")) {
					this.saveDevicePortTank({
						body: this.current_user.unit_of_measure_display == "imperial" ? this.iot_device_port_tank_imperial : this.iot_device_port_tank_metric,
					}).then((data) => {
						if (data && data.code == "200") {
							this.closePortTankDialog();
							this.getDevice(false);
						}
					});
				}
			});
		},
		deletePortTank() {
			this.removeDevicePortTank({ id: this.current_tank.id }).then((data) => {
				if (data && data.code == "200") {
					this.closePortTankDialog();
					this.$refs.delete_tank.close();
					this.getDevice(false);
					this.current_port.tank_specs.splice(
						this.current_port.tank_specs.findIndex((tank) => tank.id == this.current_tank.id),
						1
					);
				}
			});
		},
		deletePort() {
			this.removeDevicePort({ port_id: this.current_port.device_ports_id, device_id: this.device.device_id }).then((data) => {
				if (data && data.code == "200") {
					this.closePortDialog();
					this.$refs.delete_port.close();
					this.getDevice(false);
				}
			});
		},
		toggleSimState() {
			if (!this.device || !this.device.mobile || (this.device.mobile.sim_state || "").includes("PENDING")) return;

			this.$store
				.dispatch("fetchDevices", {
					url: `devices/${this.device_id}/${this.device.mobile.sim_state == "LIVE" ? "pause_sim" : "activate_sim"}`,
					method: "get",
					stateProperty: "device|ports|entity_addresses",
					dataProperty: "device|device.ports|device.entity_addresses",
					commit: true,
					body: this.iot_device,
				})
				.then((data) => {
					if (!data) return;

					this.startDeviceRefresh();
				});
		},
		startDeviceRefresh() {
			this.refresh_timer = setInterval(this.getDevice, 10 * 1000, false); // 10 seconds
		},
		saveDeviceTag(type) {
			if (type == "new") {
				let body = {
					type: "new",
					device_id: this.device.device_id,
					tag: this.edit_tag,
				};
				body.tag["company_id"] = this.device.company_id;
				this.addDeviceTag({ body: body }).then((data) => {
					if (data) {
						this.getDevice(false);
						this.fetchTags({ body: { options: 1, company_id: this.device.company_id } });
						this.closeTagDialog();
						this.current_tags = [];
						this.device_tag_mode = "add";
					}
				});
			} else if (type == "existing") {
				let body = {
					type: "existing",
					device_id: this.device.device_id,
					tags: this.current_tags.join("%7C"),
				};
				this.addDeviceTag({ body: body }).then((data) => {
					if (data) {
						this.getDevice(false);
						this.fetchTags({ body: { options: 1, company_id: this.device.company_id } });
						this.closeTagDialog();
						this.current_tags = [];
						this.device_tag_mode = "add";
					}
				});
			}
		},
		closeTagDialog() {
			this.tag_dialog = false;
			this.$refs.remove_tags.close();
			this.attach_tag_id = null;
			this.$store.commit("validationOff");
			this.$store.commit("toggleModalLoader", false);
		},
		openPortDialog(port = null) {
			this.$store.commit("validationOff");

			this.$nextTick(() => {
				if (port) {
					this.current_port = JSON.parse(JSON.stringify(port));
					if (!this.current_port.tank_specs) this.current_port.tank_specs = [];
					this.adjustHeaders(this.current_port);
				}

				this.port_dialog = true;
				this.assignObj(this.iot_device_port, port, this.rules_iot_device_port);

				this.getTankTypes();
				this.getTankProducts();
				this.getSensorTypes();
				if (port == null) {
					this.iot_device_port.port_number = this.portNumberOptions[0];
				}
			});
		},
		openAccessDialog() {
			this.fetchDeviceUsers({ body: { device_id: this.device.device_id } }).then((data) => {
				if (data) {
					this.device_users = data.users_to_devices;
					this.access_dialog = true;
				}
			});
		},
		goToPerson(person_id) {
			const routeData = this.$router.resolve({
				name: "person",
				params: { id: person_id },
			});
			window.open(routeData.href, "_blank");
		},
		getTankTypes() {
			this.$store.dispatch("fetchTankType", {
				url: "tank_types",
				method: "get",
				stateProperty: "tank_types",
				commit: true,
			});
		},
		getTankProducts() {
			this.$store.dispatch("fetchTankProducts", {
				url: "tank_products",
				method: "get",
				stateProperty: "tank_products",
				commit: true,
				body: {
					company_id: this.device.company_id,
					options: 1,
				},
			});
		},
		getDevices() {
			this.$store.dispatch("fetchDevices", {
				body: {
					company_id: this.device.company_id,
					options: 1,
				},
			});
		},
		getSensorTypes() {
			this.$store.dispatch("fetchSensorType", {
				url: "sensor_types",
				method: "get",
				stateProperty: "sensor_types",
				commit: true,
			});
		},
		modifyPort() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("iot_device_port")) {
					delete this.iot_device_port.tank_specs;
					if (this.current_port != null && this.$isSet(this.current_port.device_ports_id))
						this.iot_device_port.device_ports_id = this.current_port.device_ports_id;
					this.saveDevicePort({ body: this.iot_device_port, device_id: this.device.device_id }).then((data) => {
						if (data && data.code == "200") {
							if (data.ports.device_ports_id) this.iot_device_port.device_ports_id = data.ports.device_ports_id;
							this.current_port = data.ports;
							if (this.current_port.tank_specs == null) this.current_port.tank_specs = [];
							this.assignObj(this.iot_device_port, data.ports, this.rules_iot_device_port);
							this.adjustHeaders(this.current_port);
							this.getDevice(false);
						}
					});
				}
			});
		},
		closePortDialog() {
			this.port_dialog = false;
			this.$store.commit("validationOff");
			this.$store.commit("toggleModalLoader", false);
			this.current_port = null;
			this.iot_device_port = {
				port_number: "",
				product_id: "",
				tank_type_id: "",
				sensor_type_id: "",
				reorder_yellow: "",
				reorder_red: "",
				tank_specs: [],
			};
		},
		getIotDeviceTypes() {
			this.$store.dispatch("fetchDevices", {
				url: "device_types",
				method: "get",
				stateProperty: "device_types",
				dataProperty: "iot_device_types",
				commit: true,
			});
		},
		updateAddresses(addresses) {
			this.device.entity_addresses = addresses;
			this.iot_device.entity_addresses = addresses;
		},
		openMoveProductsDialog() {
			if (this.devices == null) this.getDevices();
			this.move_products_dialog = true;
		},
		updateAddresses(addresses) {
			this.getDevice();
		},
		openPortHistoryDialog(port) {
			let body = { device_id: port.device_id, port_id: port.device_ports_id };
			this.fetchPortHistoryGraph({ body: body }).then((data) => {
				if (data && data.port_history_graph) {
					this.portHistoryName = port.product_name || "";
					this.portHistoryData = data.port_history_graph;
					this.portHistoryGraphDialog = true;
				}
			});
		},
		openRemoveTagFromDeviceDialog(tag_id) {
			this.delete_tag_id = tag_id;
			this.$refs.delete_tag_from_device.openDialog();
		},
		removeTagFromDevice() {
			if (!this.delete_tag_id) return;

			let body = {
				device_id: this.device.device_id,
				tag_id: this.delete_tag_id,
			};
			this.removeDeviceTag({ body: body }).then((data) => {
				if (data) {
					this.$refs.delete_tag_from_device.close();
					this.getDevice(false);
				}
			});
		},
		closeSubscriptionDialog() {
			this.subscription_dialog = false;
			this.validationOff();
			this.toggleModalLoader(false);
			this.subscription.id = null;
			this.$refs.form_subscription.reset();
			this.subscription = {
				device_id: "",
				account_id: "",
				subscription_type_id: "",
				start_date: "",
				end_date: "",
				status: "active",
			};
		},
		openSubscriptionDialog() {
			this.fetchSubscriptionPlans({
				body: "",
			}).then((data) => {
				if (typeof data !== "undefined" && data.subscription_plans) {
				}
			});

			if (this.company_options.length == 0) this.fetchCompanies({ body: { options: 1 } });

			if (!this.$isSet(this.device.company_id)) {
				this.no_account_dialog = true;
				return;
			}
			this.subscription.company_id = this.device.company_id;
			this.subscription.device_id = this.device.device_id;
			this.subscription.period_start = new Date().toISOString().split("T")[0];
			this.subscription_dialog = true;
		},
		saveSubscriptions() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_subscription")) {
					let body = this.prepForm(this.subscription, this.rules_subscriptions);

					this.saveSubscription({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							this.closeSubscriptionDialog();
							this.getDevice({ status: false, ports: true });
						} else {
							//this.toggleModalLoader(false);
						}
					});
				}
			});
		},
		reprovisionDevice() {
			if (this.reprovision_validation != this.device.public_id) {
				Vue.notify({
					group: "loggedIn",
					type: "error",
					text: "The Device Number you entered is incorrect. Please try again.",
				});
			} else {
				this.$store.commit("toggleModalLoader", true);
				this.reproviseDevice({ body: { device_id: this.device.device_id } }).then((data) => {
					if (data.status == 200) {
						this.$store.commit("toggleModalLoader", false);
						this.$refs.reprovision.close();
						this.getDevice(false);
					}
				});
			}
		},
		getBatteryGraph() {
			this.$store.commit("toggleModalLoader", true);
			this.fetchBatteryGraph({ body: { id: this.device.device_id } }).then((data) => {
				if (data.battery_graph) {
					this.batteryData = data.battery_graph;
				}
				this.$store.commit("toggleModalLoader", false);
			});
		},
		openBatteryGraph() {
			this.batteryGraphDialog = true;
			this.getBatteryGraph();
		},
		moveProducts() {
			if (this.move_product_device_validation != this.device.public_id) {
				Vue.notify({
					group: "loggedIn",
					type: "error",
					text: "The Current Device Number you entered is incorrect. Please try again.",
				});
			} else if (this.move_product_new_device_validation != this.devices.filter((d) => d.device_id == this.move_to_device_id)[0].public_id) {
				Vue.notify({
					group: "loggedIn",
					type: "error",
					text: "The New Device Number you entered is incorrect. Please try again.",
				});
			} else {
				let body = {
					device_id: this.device.device_id,
					to_device_id: this.move_to_device_id,
				};
				this.$store.commit("toggleModalLoader", true);
				this.saveProductMove({ body: body }).then((data) => {
					if (data) {
						this.$store.commit("toggleModalLoader", false);
						this.move_products_dialog = false;
						this.getDevice(false);
					}
				});
			}
		},
		duplicateTank(item) {
			let newItem = this.assignObj2(item, this.rules_iot_device_port_tank_metric);
			let body = {};
			if (this.current_user.unit_of_measure_display == "imperial") {
				body = {
					device_ports_id: this.current_port.device_ports_id,
					tank_type_id: this.current_port.tank_type_id,
					unit_of_measure: this.current_user.unit_of_measure_display,
					imperial_diameter: newItem.imperial_diameter,
					imperial_height: newItem.imperial_height,
					imperial_length: newItem.imperial_length,
					imperial_width: newItem.imperial_width,
					imperial_sensor_offset: newItem.imperial_sensor_offset,
					def_us_gallons: newItem.def_us_gallons,
				};
			} else {
				body = {
					device_ports_id: this.current_port.device_ports_id,
					tank_type_id: this.current_port.tank_type_id,
					unit_of_measure: this.current_user.unit_of_measure_display,
					metric_diameter: newItem.metric_diameter,
					metric_height: newItem.metric_height,
					metric_length: newItem.metric_length,
					metric_width: newItem.metric_width,
					metric_sensor_offset: newItem.sensor_offset,
					def_liters: newItem.def_liters,
				};
			}

			Object.keys(body).forEach((key) => {
				if ((key.includes("metric_") || key.includes("imperial_")) && (body[key] == "" || body[key] == null)) {
					delete body[key];
				}
			});

			this.saveDevicePortTank({ body: body }).then((data) => {
				if (data && data.code == "200") {
					this.port_tank_dialog = false;
					this.getDevice(false);
				}
			});
		},
		async refresh(force = false) {
			if (this.customer_options.length == 0) {
				await this.fetchCustomers({ body: { options: 1 } });
			}
			if (this.devices.length == 0) await this.getDevices();
			if (this.device_types.length == 0) await this.fetchDeviceTypes({ body: { options: 1 } });
			if (this.device.company_id) {
				await this.fetchTags({ body: { options: 1, company_id: this.device.company_id } });
				this.$store.commit("updateTagOptions", [...this.tags, ...this.device.iot_device_tags]);
			} else {
				this.$store.commit("updateTagOptions", []);
			}

			if (this.mobile_providers.length == 0 || force == true) {
				this.fetchMobileProviders({ body: {} }).then((data) => {
					if (data && data.mobile_providers) {
						this.mobile_providers = data.mobile_providers;
					}
				});
			}
		},
		changeAddress(address) {
			this.device.entity_addresses = address;
		},
		getLT14DeviceLogs() {
			this.$store.commit("toggleModalLoader", true);
			this.fetchLT14DeviceLogs({ body: { device_id: this.device.device_id } }).then((data) => {
				this.$store.commit("toggleModalLoader", false);
			});
		},
		openOrderDialog() {
			this.orderDialog = true;

			this.fetchTransactionDocuments({
				body: { device_id: this.device.device_id },
			}).then((data) => {
				if (typeof data !== "undefined" && data.transaction_documents) {
					this.transaction_documents = data.transaction_documents;
					this.finishLoader();
				} else {
					this.$router.push({ name: "dashboard", replace: true });
				}
			});
		},
		addOrder() {
			this.transaction_document = {
				device_id: "",
				document_type: "order",
				document_date: "",
				due_date: "",
				comments: "",
				transaction_document_details: [],
			};
			this.selected_order = null;
			this.show_new_order = true;
			this.transaction_document.device_id = this.device.device_id;
			this.transaction_document.document_date = new Date().toISOString().split("T")[0];
			if (this.device.entity_addresses) {
				let device_address = this.device.entity_addresses[0];
				this.transaction_document.shipping_address_id = device_address ? device_address.entity_addresses_id : null;
				this.transaction_document.ship_location_label = device_address ? device_address.location_label : null;
				this.transaction_document.ship_address1 = device_address ? device_address.address1 : null;
				this.transaction_document.ship_address2 = device_address ? device_address.address2 : null;
				this.transaction_document.ship_city = device_address ? device_address.city : null;
				this.transaction_document.ship_state = device_address ? device_address.state : null;
				this.transaction_document.ship_zip_code = device_address ? device_address.zip_code : null;
				this.transaction_document.ship_country_iso_3166_1 = device_address ? device_address.country_iso_3 : null;
				this.transaction_document.ship_zip_code_ext = device_address ? device_address.zip_code_ext : null;
			}

			// grab the product_id and the user_available_capacity from each port in this.device.ports and push it to this.transaction_document.transaction_details
			this.device.ports.forEach((port) => {
				if (port.sensor_type_id != 4) {
					this.transaction_document.transaction_document_details.push({
						product_id: port.product_id,
						available_capacity: Math.sign(port.user_available_capacity) == -1 ? 0 : port.user_available_capacity,
						quantity: Math.sign(port.user_available_capacity) == -1 ? 0 : port.user_available_capacity,
					});
				}
			});
		},
		closeTransactionDocDialog() {
			this.orderDialog = false;
			this.selected_order = null;
			this.show_new_order = false;
			this.transaction_document = {
				device_id: "",
				document_type: "order",
				document_date: "",
				due_date: "",
				comments: "",
				transaction_document_details: [],
			};
		},
		saveTransactionDocumentForm(status) {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("transaction_document")) {
					if (status == "draft") {
						this.transaction_document.status_id = "26";
					} else {
						this.transaction_document.status_id = "27";
					}
					let body = this.prepForm(this.transaction_document, this.rules_transaction_documents);

					this.saveTransactionDocument({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							this.toggleModalLoader(false);
							this.fetchTransactionDocuments({
								body: { device_id: this.device.device_id },
							}).then((data) => {
								if (typeof data !== "undefined" && data.transaction_documents) {
									this.transaction_documents = data.transaction_documents;
									this.finishLoader();
								} else {
									this.$router.push({ name: "dashboard", replace: true });
								}
							});
							this.selectOrder(this.transaction_document.document_id);
						} else {
						}
					});
				}
			});
		},
		removeProductFromTransaction(index) {
			this.transaction_document.transaction_document_details.splice(index, 1);
		},
		addProductToTransaction() {
			this.transaction_document.transaction_document_details.push({
				product_id: this.selected_product,
				available_capacity: this.device.ports.find((port) => port.product_id == this.selected_product).user_available_capacity,
				quantity:
					Math.sign(this.device.ports.find((port) => port.product_id == this.selected_product).user_available_capacity) == -1
						? 0
						: this.device.ports.find((port) => port.product_id == this.selected_product).user_available_capacity,
			});
			this.selected_product = "";
		},
		selectOrder(doc_id) {
			this.show_new_order = false;
			this.fetchTransactionDocument({
				id: doc_id,
			}).then((data) => {
				if (data && data.transaction_documents) {
					this.selected_order = data.transaction_documents.document_id;
					this.transaction_document = data.transaction_documents;
				}
			});
		},
		deleteOrder(doc_id) {
			this.deleteTransactionDocument({ id: doc_id }).then((data) => {
				if (data && data.code == "200") {
					this.fetchTransactionDocuments({
						body: { device_id: this.device.device_id },
					}).then((data) => {
						if (typeof data !== "undefined" && data.transaction_documents) {
							this.transaction_documents = data.transaction_documents;
						}

						this.selected_order = null;
						this.show_new_order = false;
					});
				}
			});
		},
		setTankSpec() {
			let currentTankSpec = this.manu_tank_specs.find((tank) => tank.tank_spec_id == this.selectedTankSpec);
			if (currentTankSpec) {
				this.iot_device_port_tank_imperial.def_us_gallons = currentTankSpec.def_us_gallons;
				this.iot_device_port_tank_imperial.imperial_diameter = currentTankSpec.imperial_diameter;
				this.iot_device_port_tank_imperial.imperial_height = currentTankSpec.imperial_height;
				this.iot_device_port_tank_imperial.imperial_length = currentTankSpec.imperial_length;
				this.iot_device_port_tank_imperial.imperial_width = currentTankSpec.imperial_width;
				this.iot_device_port_tank_imperial.imperial_sensor_offset = parseFloat(5).toFixed(2);
			}
		},
		closePortTankDialog() {
			if (this.$isSet(this.current_tank)) {
				this.current_tank = {};
			}
			this.iot_device_port_tank_metric = {
				device_ports_id: "",
				def_liters: "",
				metric_height: "",
				metric_diameter: "",
				metric_width: "",
				metric_length: "",
				sensor_offset: "",
			};
			this.iot_device_port_tank_imperial = {
				device_ports_id: "",
				def_us_gallons: "",
				imperial_height: "",
				imperial_diameter: "",
				imperial_width: "",
				imperial_length: "",
				imperial_sensor_offset: "",
			};
			this.validationOff();
			this.port_tank_dialog = false;
		},
	},
	beforeDestroy() {
		clearInterval(this.refresh_timer);
	},
	mounted() {
		this.current_user.unit_of_measure_display == "metric"
			? (this.port_headers[2].text = this.$t("lang.available_metric_capacity"))
			: (this.port_headers[2].text = this.$t("lang.available_imperial_capacity"));
		this.current_user.unit_of_measure_display == "metric"
			? (this.port_headers[3].text = this.$t("lang.metric_capacity"))
			: (this.port_headers[3].text = this.$t("lang.imperial_capacity"));

		this.refresh();
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit("resetDevicesStore");
		this.$store.commit("resetCustomersStore");
		next();
	},
};
</script>
<style lang="css">
.v-chip__close {
	margin: 0 -3px 0 8px !important;
}

.fusioncharts-container {
	display: flex !important;
	justify-content: center !important;
}

.transaction-toolbar>.v-toolbar__content {
	padding: 0px !important;
}
</style>
